import React, { useEffect, useState, useContext } from "react";
import { Form, useNavigate } from "react-router-dom";
import TextField from "../../components/common/TextField.jsx";
// import TextField from "../../components/newCommon/TextField/Index.jsx";
import TextArea from "../../components/common/TextArea.jsx";
import NumberInput from "../../components/common/Number.jsx";
import Password from "../../components/common/Password.jsx";
import RadioSelector from "../../components/common/RadioSelector.jsx";
import ContentRenderer from "../../components/common/contentRenderer.jsx";
import CheckBoxSelector from "../../components/common/CheckBoxSelector.jsx";
import FormRendererContext from "../../services/context/FormRendererContext.js";
import {
  newFormSubmit,
  newFormSubmitForTriggers,
  updateJourneyDataForInstanceId,
} from "../../utils/form.js";
import SingleCheckBox from "../../components/common/SingleCheckBox.jsx";
import DropDownSelector from "../../components/common/DropDownSelector.jsx";
import DateInput from "../../components/common/DateInput.jsx";
import DOB from "../../components/common/DOB.jsx";
import Email from "../../components/common/Email.jsx";
import Signature from "../../components/common/Signature.jsx";
import UploadFile from "../../components/common/UploadFile.jsx";
import Telephone from "../../components/common/Telephone.jsx";
import {
  callAthenaGetApi,
  callAthenaPostApi,
  callAthenaPutApi,
} from "../../utils/athena.js";
import DropDownWithSearch from "../../components/common/DropDownWithSearch.jsx";
import HealthHistoryAllergyComponent from "../../components/common/HealthHistoryAllergyComponent.jsx";
import axios from "axios";
import Loader from "../../components/common/loader.jsx";
import ModalBox from "../../components/common/modal.jsx";
import HealthHistoryMedicationComponent from "../../components/common/HealthHistoryMedicationComponent.jsx";
import AmericanPhoneField from "../../components/common/AmericanPhoneField.jsx";
import DynamicContentRenderer from "../../components/common/DynamicContentRenderer.jsx";
import moment from "moment";
import HeightField from "../../components/common/Height.jsx";
import DataGrid from "../../components/common/DataGrid.jsx";
import Columns from "../../components/common/Column.jsx";
const timezoneMapper = {
  est: -5,
  cst: -6,
  mst: -7,
  pst: -8,
  akst: -9,
  hst: -10,
};

const FormRenderer = ({
  formData,
  handleNextScreenPage,
  handleBackScreenPage,
  activeFormPageData,
  firstPageFirstFormID,
  formClass,
  isLastForm = false,
}) => {
  const [formSchema, setFormSchema] = useState(null);
  const [formAnswer, setFormAnswer] = useState(null);
  const [activeFormPage, setActiveFormPage] = useState(null);
  const [activeFormPageId, setActiveFormPageId] = useState(null);
  const [showloader, setShowLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubtitle, setModalSubtitle] = useState("");

  const [formattedAnswer, setFormattedAnswer] = useState(null);

  const [formValid, setFormValidation] = useState(true);

  const [formTriggers, setFormTriggers] = useState(null);

  const [allDepartmentsForSpecificForm, setAllDepartmentsForSpecificForm] =
    useState([]);
  const [allReasonsForSpecificForm, setAllReasonsForSpecificForm] =
    useState(null);

  const { answerData, setAnswerData, socialKeys } =
    useContext(FormRendererContext);
  const {
    journeyData,
    deviceType,
    setJourneyData,
    activeScreenID,
    activeScreenPageID,
    completeJourneyAnswers,
    setCompleteJourneyAnswers,
    setHBxFirstName,
    setHBxLastName,
    setHBxEmail,
    setHBxDob,
    HBxReasonForVisit,
    setHBxReasonForVisit,
    journeyId,
    patientIdFromQP,
    appointmentIdFromQP,
    hashIdFromQP,
    allergyData,
    medicationData,
    patientTZ,
    setPatientTZ,
    insuranceCollectedStatus,
    paymentCollectedStatus,
    setScheduler_id,
    hashFromQP,
    qnABodyForTriggers,
    setQnABodyForTriggers,
    journeyInstanceId,
    setDepartment_id,
  } = useContext(FormRendererContext);
  let navigate = useNavigate();

  const paymentForm = "66ec5b455b3a1419fb717b99";
  const paymentFormProd = "6819ad9dc4f18e73b7d06d38";
  const insuranceForm = "66e918895b3a1419fb7132b7";
  const insuranceFormProd = "6819af55c4f18e73b7d06d4d";

  const getWidgetId = (data) => {
    const screens = data?.journey_schema?.screens || [];
    for (const screen of screens) {
      for (const page of screen?.screenPages || []) {
        const component = page?.components;
        if (component?.type === "scheduler-widget") {
          return component?.widget?.id || null;
        }
      }
    }
    return null; // Return null if no widget ID is found
  };

  async function uploadDemographics() {
    const demographicsAnswer = {
      firstName: answerData?.demographicsPatientFirstName?.value || "",
      middleName: answerData?.demographicsMiddleInitial?.value || "",
      lastName: answerData?.demographicsPatientLastName?.value || "",
      address: {
        streetAddress: answerData?.demographicsStreetAddress?.value || "",
        ZIP: parseInt(answerData?.demographicsZipCode?.value, 10) || "",
        city: answerData?.demographicsCity?.value || "",
        state: answerData?.demographicsState?.value || "",
        country: answerData?.demographicsCountry?.value || "",
      },
      phoneNumber: {
        home: answerData?.demographicsHomePhone?.value || "",
        work: answerData?.demographicsWorkPhone?.value || "",
        mobile: answerData?.demographicsMobilePhone?.value || "",
        // mobile: "(786) 767-7772demographicsMobilePhone",
      },
      sex: answerData?.demographicsLegalGender?.value || "",
      maritalStatus: answerData?.demographicsMaritalStatus?.value || "",
      email: answerData?.demographicsEmail?.value
        ? [answerData?.demographicsEmail?.value]
        : [],
      race: answerData?.demographicsRace?.value || "",
      ethnicity: answerData?.demographicsEthnicity?.value || "",
      SSN: answerData?.demographicsSsn?.value || "",
      language: answerData?.demographicsPreferredLanguage?.value || "",
      consentToCall:
        answerData?.demographicsConsentToCall?.value === "yes" ? true : false,
      consentToText:
        answerData?.demographicsConsentToTextYou?.value === "yes"
          ? true
          : false,
      emergencyContact: {
        name:
          answerData?.demographicsEmergencyFirstName?.value &&
          answerData?.demographicsEmergencyLastName?.value
            ? answerData?.demographicsEmergencyFirstName?.value +
              " " +
              answerData?.demographicsEmergencyLastName?.value
            : "",
        phone: answerData?.demographicsEmergencyMobilePhone?.value || "",
        relationship:
          answerData?.demographicsEmergencyRelationship?.value || "",
      },
    };
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const putDemographicsUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient`;
    try {
      // submit demographiocs data
      const demographicResponse = await callAthenaPutApi(
        putDemographicsUrl,
        demographicsAnswer
      );
      // Check for demographic API failure
      if (!demographicResponse || demographicResponse.error) {
        alert("Demographics upload failed");
        return false;
      }

      // submit demographic image
      const binaryLinkUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/binary`;
      if (answerData?.demographicsPhoto?.value) {
        const file = answerData?.demographicsPhoto?.value;
        const fileName = file?.name;
        const fileType = file?.type;

        const imageResponse = await callAthenaPostApi(binaryLinkUrl, {
          contentType: fileType,
          fileName: fileName,
        });
        // Check for image upload URL failure
        if (!imageResponse || imageResponse.error) {
          alert("Failed to get image upload URL");
          return false;
        }

        const { uploadUrl } = imageResponse?.data?.HBx;
        const { fileUrl } = imageResponse?.data?.HBx;
        const formData = new FormData();
        formData.append("file", file);
        await axios.put(uploadUrl, file);

        // delaying 300 ms for complete upload of image on s3 server
        await new Promise((resolve) => setTimeout(resolve, 300));

        const postUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/driverslicense`;
        const fileResponse = await callAthenaPostApi(postUploadUrl, {
          fileName: fileName,
          contentType: fileType,
          HBxUrl: fileUrl,
        });
        // Check for final image API failure
        if (!fileResponse || fileResponse.error) {
          alert("Image metadata submission failed");
          return false;
        }
      }
      return true;
    } catch (error) {
      // Catch any other unexpected errors
      alert("Error during demographics upload:", error);
      return false;
    }
  }
  async function uploadSleepTest() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const schedulerId = getWidgetId(journeyData);
    try {
      // submit demographic image
      const binaryLinkUrl = `${API_URL}/api/v1/booking/upload-url/${schedulerId}/${hashFromQP}`;
      if (answerData?.uploadSleepTest?.value) {
        const file = answerData?.uploadSleepTest?.value;
        const fileName = file?.name;
        const fileType = file?.type;

        const imageResponse = await callAthenaPostApi(binaryLinkUrl, {
          contentType: fileType,
          fileName: fileName,
        });
        // Check for image upload URL failure
        if (!imageResponse || imageResponse.error) {
          alert("Failed to get image upload URL");
          return false;
        }

        const { uploadUrl } = imageResponse?.data;
        const { fileUrl } = imageResponse?.data;
        const formData = new FormData();
        formData.append("file", file);
        await axios.put(uploadUrl, file);

        // delaying 300 ms for complete upload of image on s3 server
        await new Promise((resolve) => setTimeout(resolve, 300));

        const postUploadUrl = `${API_URL}/api/v1/booking/document/${schedulerId}/${hashFromQP}`;
        const fileResponse = await callAthenaPostApi(postUploadUrl, {
          fileName: fileName,
          contentType: fileType,
          fileUrl: fileUrl,
        });
        // Check for final image API failure
        if (!fileResponse || fileResponse.error) {
          alert("Image metadata submission failed");
          return false;
        }
      }
      return true;
    } catch (error) {
      // Catch any other unexpected errors
      alert("Error during sleep test upload:", error);
      return false;
    }
  }
  async function uploadAdditionalInfo() {
    if (answerData?.additionalInfoConsent?.value === "yes") {
      const additionalInfo = {
        sexualOrientation: answerData?.sexualOrientation?.value || "",
        sexualOrientationOther: "",
        genderIdentity: answerData?.genderIdentity?.value || "",
        genderOther: "",
        sexAtBirth: answerData?.sexAtBirth?.value || "",
        pronouns: answerData?.pronouns?.value || "",
        homebound: answerData?.homebound?.value === "yes" ? "true" : "false",
        referralSourceId: answerData?.referralSourceId?.value || "",
        referralSourceOther: "",
      };
      const API_URL = process.env.REACT_APP_SCHEDULER_URL;
      const uploadAdditionalInfoUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient`;
      try {
        const response = await callAthenaPutApi(
          uploadAdditionalInfoUrl,
          additionalInfo
        );
        // Check for API failure
        if (!response || response.error) {
          alert("Additional info upload failed");
          return false;
        }
        if (
          journeyId === "6710106ced976ad58926ecb1" ||
          journeyId === "67101074ed976ad58926ecb2"
        ) {
          return uploadInsurance();
        }

        // If successful, return true
        return true;
      } catch (error) {
        // Catch any unexpected errors
        alert("Error during additional info upload:", error);
        return false;
      }
    }
    return true;
  }
  function dateFormatter(date) {
    const formattedDate = moment(date?.$d).format("MM/DD/YYYY");
    return formattedDate;
  }
  async function uploadInsurance() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const uploadInsuranceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage`;
    const appointmentCoverageUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/coverage`;

    if (answerData?.areYouUsingYourInsuranceForTheVisit?.value === "yes") {
      //Insurance
      const insPlans = [
        {
          insurancePackageId: "0",
          name: "*SELF PAY*",
          ranking: "1",
          percentage: "65.36458333333333333333333333333333333333",
          address: {},
        },
        {
          insurancePackageId: "31724",
          name: "HUMANA (PPO)",
          productTypeName: "PPO",
          ranking: "2",
          percentage: "11.1328125",
          phone: "(800) 558-4444",
          address: {
            streetaddress: "PO BOX 14601",
            city: "LEXINGTON",
            state: "KY",
            ZIP: "40512-4601",
          },
        },
        {
          insurancePackageId: "20995",
          name: "HUMANA - GOLD PLUS (MEDICARE REPLACEMENT HMO)",
          productTypeName: "Medicare HMO",
          ranking: "3",
          percentage: "2.47395833333333333333333333333333333333",
          phone: "(800) 448-6262",
          address: {
            streetaddress: "PO BOX 14601",
            city: "LEXINGTON",
            state: "KY",
            ZIP: "40512-4601",
          },
        },
        {
          insurancePackageId: "1352",
          name: "AETNA",
          productTypeName: "OTHER",
          ranking: "4",
          percentage: "1.82291666666666666666666666666666666667",
          phone: "(888) 632-3862",
          address: {
            streetaddress: "PO BOX 981106",
            city: "EL PASO",
            state: "TX",
            ZIP: "79998-1106",
          },
        },
        {
          insurancePackageId: "-500",
          name: "PAYMENT PLAN",
          ranking: "5",
          percentage: "1.43229166666666666666666666666666666667",
          address: {},
        },
        {
          insurancePackageId: "8477",
          name: "BCBS-MA: BCBS (PPO)",
          productTypeName: "PPO",
          ranking: "6",
          percentage: ".9114583333333333333333333333333333333333",
          phone: "(800) 882-2060",
          address: {
            streetaddress: "PO BOX 986020",
            city: "BOSTON",
            state: "MA",
            ZIP: "02298-6020",
          },
        },
        {
          insurancePackageId: "92125",
          name: "AETNA - OLYMPUS HEALTHCARE (PPO)",
          productTypeName: "PPO",
          ranking: "7",
          percentage: ".5859375",
          phone: "(866) 936-1225",
          address: {
            streetaddress: "PO BOX 30259",
            city: "TAMPA",
            state: "FL",
            ZIP: "33630-3259",
          },
        },
        {
          insurancePackageId: "569524",
          name: "BCBS-RI (MEDICARE REPLACEMENT/ADVANTAGE - PPO)",
          productTypeName: "Medicare PPO",
          ranking: "7",
          percentage: ".5859375",
          phone: "(800) 230-9050",
          address: {
            streetaddress: "500 EXCHANGE ST",
            city: "PROVIDENCE",
            state: "RI",
            ZIP: "02903-2630",
          },
        },
      ];

      const insurancePackageId = answerData?.insuranceCompanyName?.value;
      const selectedPlan = insPlans.find(
        (plan) => plan.insurancePackageId === insurancePackageId
      );
      const insuranceProductTypeName = selectedPlan?.productTypeName || "";
      const insuranceName = selectedPlan?.name || "";

      const insuranceData = {
        insurancePackageId: insurancePackageId
          ? parseInt(insurancePackageId, 10)
          : "",
        insuranceProductTypeName: insuranceProductTypeName,
        insuranceName: insuranceName,
        policyNumber: answerData?.policyNumber?.value || "",
        groupID: answerData?.policyGroupId?.value || "",
        // sequenceNumber: 1,
        relationshipToInsured:
          answerData?.patientsRelationshipToInsuranceHolder?.value || "",
        policyHolder: {
          firstName: answerData?.policyHolderFirstName?.value || "",
          middleName: answerData?.policyHolderMiddleName?.value || "",
          lastName: answerData?.policyHolderLastName?.value || "",
          sex: answerData?.policyHolderGender?.value || "",
          DOB: answerData?.policyHolderDOB?.value
            ? dateFormatter(answerData?.policyHolderDOB?.value)
            : "",
          address: {
            streetAddress: answerData?.policyHolderAddress?.value || "",
            ZIP: parseInt(answerData?.policyHolderZipcode?.value, 10) || "",
            city: answerData?.policyHolderCity?.value || "",
            state: answerData?.policyHolderState?.value || "",
            country: answerData?.policyHolderCountry?.value || "",
          },
        },
      };

      insuranceData["sequenceNumber"] = 1;
      try {
        const coverageResponse = await callAthenaGetApi(uploadInsuranceUrl);

        if (!coverageResponse || coverageResponse.error) {
          alert("get coverage failed");
          return false;
        }

        const HBxData = coverageResponse.data?.HBx;
        insuranceData["sequenceNumber"] = HBxData?.length
          ? HBxData?.length + 1
          : 1;

        const insuranceResponse = await callAthenaPostApi(
          uploadInsuranceUrl,
          insuranceData
        );

        if (!insuranceResponse || insuranceResponse.error) {
          alert("Insurance upload failed");
          return false;
        }

        const { HBx } = insuranceResponse.data;
        const insuranceId = HBx?.id;

        const appointmentCoverageResponse = await callAthenaPutApi(
          appointmentCoverageUrl,
          {
            primaryCoverageId: insuranceId,
          }
        );

        if (!appointmentCoverageResponse || appointmentCoverageResponse.error) {
          alert("Appointment coverage update failed");
          return false;
        }
        const handleImageUpload = async () => {
          if (answerData?.snapAPhotographOfYourInsuranceCard?.value) {
            const file1 = answerData?.snapAPhotographOfYourInsuranceCard?.value;

            const file2 =
              answerData?.snapAPhotographOfYourInsuranceCardBackSide?.value;

            try {
              // Create a canvas to combine the two images
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              // Load both images as Image objects
              const img1 = new Image();
              const img2 = new Image();

              img1.src = URL.createObjectURL(file1);
              img2.src = URL.createObjectURL(file2);

              const loadImages = () =>
                new Promise((resolve, reject) => {
                  let loadedCount = 0;

                  const onLoad = () => {
                    loadedCount += 1;
                    if (loadedCount === 2) resolve();
                  };

                  const onError = (error) => reject(error);

                  img1.onload = onLoad;
                  img2.onload = onLoad;
                  img1.onerror = onError;
                  img2.onerror = onError;
                });

              // Wait for both images to load
              await loadImages();

              // Set canvas size to combine both images (vertically stacked in this example)
              canvas.width = Math.max(img1.width, img2.width);
              canvas.height = img1.height + img2.height;

              // Draw both images on the canvas
              ctx.drawImage(img1, 0, 0);
              ctx.drawImage(img2, 0, img1.height);

              // Convert the combined image to binary (Blob)
              const combinedImageBlob = await new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob), "image/jpeg");
              });

              const binaryLinkUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/binary`;

              const res = await callAthenaPostApi(binaryLinkUrl, {
                contentType: combinedImageBlob?.type,
                fileName: "combined-insurance.jpg",
              });

              const { uploadUrl, fileUrl } = res?.data?.HBx;

              const postUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage/image`;
              try {
                await axios.put(uploadUrl, combinedImageBlob);

                // delaying 300 ms for complete upload of image on s3 server
                await new Promise((resolve) => setTimeout(resolve, 300));

                await callAthenaPostApi(postUploadUrl, {
                  fileName: "combined-insurance.jpg",
                  coverageId: insuranceId,
                  HBxUrl: fileUrl,
                });
              } catch (error) {
                alert(`Error uploading combined-insurance.jpg:`, error);
                return false;
              }
            } catch (error) {
              console.error("Error combining and uploading files:", error);
            }
          }
        };

        await handleImageUpload();

        return true; // Successful completion
      } catch (error) {
        alert("Error during get coverage fetch:", error);
        return false;
      }
    } else {
      return true; // Successful completion
    }
  }

  async function uploadPharmacy() {
    const pharmacyId =
      parseInt(answerData?.pharmacyProviders?.value?.clinicalProviderId, 10) ||
      "";
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const uploadPharmacyUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/pharmacy`;

    try {
      const response = await callAthenaPutApi(uploadPharmacyUrl, {
        preferredPharmacy: pharmacyId,
      });

      if (!response || response.error) {
        alert("Pharmacy upload failed");
        return false;
      }

      return true; // Successful completion
    } catch (error) {
      alert("Error during pharmacy upload:", error);
      return false;
    }
  }

  async function uploadCareTeam() {
    const primaryCareProviderId =
      parseInt(
        answerData?.primaryCarePhysician?.value?.clinicalProviderId,
        10
      ) || "";
    const referringProviderId =
      parseInt(answerData?.referredPhysician?.value?.clinicalProviderId, 10) ||
      "";

    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const primaryCareProviderUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/careteam/primaryprovider`;
    const referringCareProviderUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/careteam/referringprovider`;

    try {
      // Upload Primary Care Provider
      if (primaryCareProviderId) {
        const primaryResponse = await callAthenaPutApi(primaryCareProviderUrl, {
          clinicalProviderId: primaryCareProviderId,
        });

        if (!primaryResponse || primaryResponse.error) {
          alert("Primary Care Provider upload failed");
          return false;
        }
      }

      if (referringProviderId) {
        // Upload Referring Provider
        const referringResponse = await callAthenaPutApi(
          referringCareProviderUrl,
          {
            clinicalProviderId: referringProviderId,
          }
        );

        if (!referringResponse || referringResponse.error) {
          alert("Referring Provider upload failed");
          return false;
        }
      }

      return true; // Successful completion
    } catch (error) {
      alert("Error during care team upload:", error);
      return false;
    }
  }

  async function uploadMedicalCondition() {
    const dateFormatter = (dateString) => {
      if (dateString) {
        const date = new Date(dateString);

        const formattedDate =
          (date.getMonth() + 1).toString().padStart(2, "0") +
          "/" +
          date.getDate().toString().padStart(2, "0") +
          "/" +
          date.getFullYear();
        return formattedDate;
      }
      return dateString;
    };

    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const API_URL_PDF = process.env.REACT_APP_PDF_RENDERER_URL;
    const allergyHistoryUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/healthhistory/5792`;
    const medicationHistoryUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/healthhistory/5793`;
    const pdfUploadUrl = `${API_URL_PDF}/api/v1/pdf/${hashIdFromQP}/render`;
    const putMedicalHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/medicalhistory`;

    const medicalConditions =
      answerData?.pleaseEnterYourMedicalConditionSBelow?.value || {};
    const medicalData = [];
    Object.keys(medicalConditions)?.map((key) => {
      if (medicalConditions[key] === "true" || medicalConditions[key]) {
        medicalData.push({
          questionid: key,
          answer: "Y",
        });
      }
    });
    // const medicalData = medicalConditions.map((item) => ({
    //   questionid: item,
    //   answer: "Y",
    // }));

    const medicalResponse = await callAthenaPutApi(putMedicalHistoryUrl, {
      data: medicalData,
    });

    if (!medicalResponse || medicalResponse.error) {
      alert("Medical conditions upload failed");
      return false;
    }

    if (allergyData) {
      const groupedData = allergyData.reduce((acc, curr) => {
        curr.components.forEach((component) => {
          if (component.type === "searchAllergy") {
            const allergyId = component.selectedOption;
            let existingEntry = acc.find(
              (entry) => entry.allergyid === allergyId
            );

            if (!existingEntry) {
              existingEntry = {
                allergyid: allergyId,
                onsetdate: "",
                allergyreactionid: [],
                severityid: [],
              };
              acc.push(existingEntry);
            }

            // Find the corresponding onset date, reactions, and severity for this allergy
            curr.components.forEach((subComponent) => {
              if (subComponent.subKey === "onsetdate") {
                existingEntry.onsetdate = subComponent.selectedOption;
              }
              if (subComponent.subKey === "allergyreactionid") {
                existingEntry.allergyreactionid.push(
                  subComponent.selectedOption
                );
              }
              if (subComponent.subKey === "severityid") {
                existingEntry.severityid.push(subComponent.selectedOption);
              }
            });
          }
        });
        return acc;
      }, []);

      // Format the final output
      const allergyOutput = {
        questions: groupedData.map((item) => ({
          allergyid: item.allergyid.toString(),
          onsetdate: dateFormatter(item.onsetdate),
          allergyreactionid: item.allergyreactionid, // keep all reactions in an array
          severityid: item.severityid, // keep all severities in an array
        })),
      };

      try {
        const allergyHistoryUploadResponse = await callAthenaPutApi(
          allergyHistoryUploadUrl,
          {
            data: [
              {
                portalformsectionid: 7556,
                complete: true,
                ...allergyOutput,
              },
            ],
          }
        );

        if (
          !allergyHistoryUploadResponse ||
          allergyHistoryUploadResponse.error
        ) {
          alert("Allergy history upload failed");
          return false;
        }
      } catch (error) {
        alert("Error during Allergy history upload:", error);
        return false;
      }
    }

    if (medicationData) {
      const result = medicationData.map((item) => {
        const components = item.components;

        const medication = components.find(
          (comp) => comp.subKey === "searchMedication"
        );
        const startDate = components.find(
          (comp) => comp.subKey === "startdate"
        );
        const stopDate = components.find((comp) => comp.subKey === "stopdate");
        const reasonForDiscontinuation = components.find(
          (comp) => comp.subKey === "meddeactivatereasonid"
        );
        const frequency = components.find(
          (comp) => comp.subKey === "frequency"
        );
        const dosagequantity = components.find(
          (comp) => comp.subKey === "dosagequantity"
        );
        return {
          medicationid: medication?.selectedOption,
          startdate: dateFormatter(startDate?.selectedOption),
          stopdate: dateFormatter(stopDate?.selectedOption),
          meddeactivatereasonid: reasonForDiscontinuation?.selectedOption,
          frequency: frequency?.selectedOption,
          displaydosageunits: "mg", //"tablet(s)",
          dosagequantity: dosagequantity?.selectedOption,
        };
      });

      try {
        const medicationHistoryUploadResponse = await callAthenaPutApi(
          medicationHistoryUploadUrl,
          {
            data: [
              {
                portalformsectionid: 7557,
                complete: true,
                questions: result,
              },
            ],
          }
        );

        if (
          !medicationHistoryUploadResponse ||
          medicationHistoryUploadResponse.error
        ) {
          alert("Medication history upload failed");
          return false;
        }
      } catch (error) {
        alert("Error during Medication history:", error);
        return false;
      }
    }

    return true;
  }

  async function uploadSocialCondition() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const API_URL_PDF = process.env.REACT_APP_PDF_RENDERER_URL;
    const pdfUploadUrl = `${API_URL_PDF}/api/v1/pdf/${hashIdFromQP}/render`;
    const getSocialHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/socialhistory`;

    const socialData = [];

    socialKeys.forEach((key) => {
      if (answerData?.[key]?.value) {
        // Check if the key exists and has a value
        socialData.push({
          key: key,
          answer: answerData[key].value,
        });
      }
    });

    const response = await callAthenaPutApi(getSocialHistoryUrl, {
      data: socialData,
    });

    // Check for response validity
    if (!response || response.error) {
      alert("Social history upload failed");
      return false;
    }
    return true;
  }

  async function uploadPrivacy() {
    try {
      // Upload privacy information
      const signatureName = answerData?.patientGuardianSignature?.value || "";
      const dateTime =
        formatTimestamp(answerData?.patientGuardianSignature?.time) || "";

      const API_URL = process.env.REACT_APP_SCHEDULER_URL;
      const postPrivacyNoticeUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/consent/privacynotice`;
      const postRealeaseOfBillingInformationUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/consent/realeaseofbillinginformation`;
      const postAssignmentOfBenefitsUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/consent/assignmentofbenefits`;

      const privacyTypes = [
        {
          type: "Privacy Notice",
          expirationDate: null,
          apiUrl: postPrivacyNoticeUrl,
        },
        {
          type: "Release of Billing Information",
          expirationDate: addOneYearToDate(dateTime),
          apiUrl: postRealeaseOfBillingInformationUrl,
        },
        {
          type: "Assignment of Benefits",
          expirationDate: addOneYearToDate(dateTime),
          apiUrl: postAssignmentOfBenefitsUrl,
        },
      ];

      for (const privacy of privacyTypes) {
        const response = await callAthenaPostApi(privacy?.apiUrl, {
          signatureName: signatureName,
        });

        // Check for response validity
        if (!response || response.error) {
          alert(`${privacy?.type} upload failed`);
          return false;
        }
      }
      const documentConsentUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/document/consent`;
      const documentClinicalUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/document/clinical`;

      return true; // Successful completion
    } catch (error) {
      alert("Error during privacy upload:", error);
      return false;
    }
  }

  async function submitDocument(
    fileName,
    contentText,
    documentType,
    documentTypeUploadUrl
  ) {
    const pdfContent = [
      "%PDF-1.4",
      "1 0 obj",
      "<< /Type /Catalog /Pages 2 0 R >>",
      "endobj",
      "2 0 obj",
      "<< /Type /Pages /Kids [ 3 0 R ] /Count 1 >>",
      "endobj",
      "3 0 obj",
      "<< /Type /Page /Parent 2 0 R /MediaBox [ 0 0 612 792 ] /Contents 4 0 R >>",
      "endobj",
      "4 0 obj",
      "<< /Length 44 >>",
      "stream",
      "BT",
      "/F1 24 Tf",
      "100 700 Td",
      `${contentText} Tj`,
      "ET",
      "endstream",
      "endobj",
      "xref",
      "0 5",
      "0000000000 65535 f",
      "0000000009 00000 n",
      "0000000090 00000 n",
      "0000000153 00000 n",
      "0000000198 00000 n",
      "trailer",
      "<< /Size 5 /Root 1 0 R >>",
      "startxref",
      "252",
      "%%EOF",
    ].join("\n");

    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const binaryLinkUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/binary`;

    const pdfBlob = new Blob([pdfContent], { type: "application/pdf" });
    const formData = new FormData();
    formData.append("file", pdfBlob, fileName);

    try {
      const res = await callAthenaPostApi(binaryLinkUrl, {
        contentType: "pdf",
        fileName: fileName,
      });

      const { uploadUrl, fileUrl } = res?.data?.HBx;

      await axios.put(uploadUrl, pdfBlob);

      // delaying 300 ms for complete upload of image on s3 server
      await new Promise((resolve) => setTimeout(resolve, 300));

      await callAthenaPostApi(documentTypeUploadUrl, {
        contentType: "PDF",
        internalNote: documentType === "ADMIN_CONSENT" ? "Hipaa" : "Clinical",
        fileName: fileName,
        HBxUrl: fileUrl,
      });
    } catch (error) {
      alert(`Error uploading ${fileName}:`, error);
      return false;
    }
  }

  async function uploadPaymentDetails() {
    const iDontWantToAddMyCardOnFile =
      answerData?.["iDontWantToAddMyCardOnFile"]?.value == true;
    const UseYourCardOnFile =
      answerData?.selectHowSynaptrxSleepCanUseYourCardOnFile?.value || "";
    if (!iDontWantToAddMyCardOnFile) {
      const paymentType = UseYourCardOnFile;
      try {
        // Upload Payment deatils
        const content = {
          email: answerData?.paymentEmail?.value || "",
          maxAmount: Math.min(
            parseInt(answerData?.paymentAmount?.value || "", 10),
            1500
          ),
          nameOnCard: answerData?.nameOnCard?.value || "",
          cardNumber: answerData?.cardNumber?.value || "",
          cvv: parseInt(answerData?.cvv?.value || "", 10),
          address: {
            streetAddress: answerData?.paymentAddress?.value || "",
            ZIP: parseInt(answerData?.paymentZipCode?.value || "", 10),
            city: answerData?.paymentCity?.value || "",
            state: answerData?.paymentState?.value || "",
            country: answerData?.paymentCountry?.value || "",
          },
          expirationDate: answerData?.expirationDate?.value || "",
        };

        const API_URL = process.env.REACT_APP_SCHEDULER_URL;
        const paymentUploadUrl =
          paymentType === "singleAppointment"
            ? `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/singleappointment`
            : `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/oneyear`;
        const paymentResponse = await callAthenaPostApi(
          paymentUploadUrl,
          content
        );

        if (!paymentResponse || paymentResponse.error) {
          alert("Payment details upload failed");
          return false;
        }

        return true; // Successful completion
      } catch (error) {
        alert("Error during Payment details upload:", error);
        return false;
      }
    } else return true;
  }

  async function callAthenaAPIs() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const getGenderUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/configuration/genderIdentity`;
    const getReferralSourceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/configuration/referralsources`;
    const getInsuranceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/insuranceplan`;
    const getCoverageUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage`;
    const getMedicalHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/medicalhistory`;
    const getSocialHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/socialhistory`;
    const getPrivacyInfoUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/consent`;
    try {
      // Health history
      if (
        formData?.formId === "66e947e15b3a1419fb71449f" ||
        formData?.formId === "68525b7b4ef9cc55588fb851" ||
        formData?.formId === "6819aff5c4f18e73b7d06d59"
      ) {
        await Promise.all([callAthenaGetApi(getMedicalHistoryUrl)]);
      }

      // Social history
      if (
        formData?.formId === "66e919bd5b3a1419fb7132e5" ||
        formData?.formId === "68525b9d4ef9cc55588fb852" ||
        formData?.formId === "6819b02fc4f18e73b7d06d5d"
      ) {
        await Promise.all([callAthenaGetApi(getSocialHistoryUrl)]);
      }

      // Privacy info
      if (
        formData?.formId === "66e91d3e5b3a1419fb7132fa" ||
        formData?.formId === "68525bcd4ef9cc55588fb853" ||
        formData?.formId === "6819b084c4f18e73b7d06d61"
      ) {
        await callAthenaGetApi(getPrivacyInfoUrl);
      }
    } catch (error) {
      alert("Error during Athena API calls:", error);
    }
  }

  const fetchFormSchema = async (activeComponent) => {
    setFormSchema(activeComponent?.form?.form_schema?.formData);
    // setActiveFormPage(activeComponent?.form?.form_schema?.formData[0].content);
    // setActiveFormPageId(activeComponent?.form?.form_schema?.formData[0].id);
    setFormAnswer(activeComponent?.form);
    if (activeComponent?.updatedTriggers) {
      setFormTriggers({
        triggers: activeComponent?.updatedTriggers,
        waitForWorkflowCompletion:
          activeComponent?.waitForWorkflowCompletion || false,
        singleFormBody: false,
      });
    } else if (activeComponent?.form?.triggers) {
      setFormTriggers({
        triggers: activeComponent?.form?.triggers,
        waitForWorkflowCompletion:
          activeComponent?.waitForWorkflowCompletion || false,
        singleFormBody: true,
      });
    } else {
      setFormTriggers({
        triggers: [],
        waitForWorkflowCompletion: false,
        singleFormBody: false,
      });
    }
  };

  const findAllComponents = (
    components,
    result = [],
    parentDatagrid = null,
    parentDatagridKey = null
  ) => {
    if (!Array.isArray(components)) return result;

    components.forEach((component) => {
      const componentWithContext = { ...component };
      if (parentDatagrid) {
        componentWithContext.parentDatagrid = parentDatagrid;
        componentWithContext.parentDatagridKey = parentDatagridKey;
      }

      result.push(componentWithContext);

      if (
        component.type === "datagrid" &&
        Array.isArray(component.components)
      ) {
        findAllComponents(
          component.components,
          result,
          component,
          component.key
        );
      } else if (Array.isArray(component.components)) {
        findAllComponents(
          component.components,
          result,
          parentDatagrid,
          parentDatagridKey
        );
      }

      if (
        (component.type === "panel" || component.type === "fieldset") &&
        Array.isArray(component.components)
      ) {
        findAllComponents(
          component.components,
          result,
          parentDatagrid,
          parentDatagridKey
        );
      }

      if (component.type === "columns" && Array.isArray(component.columns)) {
        component.columns.forEach((column) => {
          if (Array.isArray(column.components)) {
            findAllComponents(
              column.components,
              result,
              parentDatagrid,
              parentDatagridKey
            );
          }
        });
      }
    });

    return result;
  };

  const deepCloneWithFiles = (obj) => {
    return structuredClone(obj);
  };

  // Function to format date and time as 'dd/MM/yyyy HH:mm:ss'
  const formatTimestamp = (dateInput) => {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  };

  function addOneYearToDate(dateInput) {
    const date = new Date(dateInput);

    // Add one year to the date
    date.setFullYear(date.getFullYear() + 1);

    const newDay = String(date.getDate()).padStart(2, "0");
    const newMonth = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const newYear = date.getFullYear();

    return `${newMonth}/${newDay}/${newYear}`;
  }

  // Function to add an answer to a specific form, form page, and question
  function addAnswerToTriggerBody(formId, activeFormPageId, question, answer) {
    const questionKey = question?.key;
    const questionLabel = question?.label;
    setQnABodyForTriggers((prevState) => {
      // Create a copy of the previous state
      const newState = { ...prevState };

      // If the form doesn't exist yet, create it
      if (!newState[formId]) {
        newState[formId] = {};
      }

      // If the form page doesn't exist yet, create it
      if (!newState[formId][activeFormPageId]) {
        newState[formId][activeFormPageId] = {};
      }

      // Determine the answer value, handling boolean values properly
      let answerValue;
      if (answer?.label !== undefined) {
        answerValue = answer.label;
      } else if (answer?.value !== undefined) {
        answerValue = answer.value; // This now properly handles boolean values
      }

      // Add the question-answer pair to the specific form page
      if (question?.type === "file") {
        if (answer?.value instanceof File) {
          newState[formId][activeFormPageId][questionKey] = {
            question: questionLabel,
            answer: question?.fileId,
          };
        } else
          newState[formId][activeFormPageId][questionKey] = {
            question: questionLabel,
            answer: null,
          };
      } else {
        newState[formId][activeFormPageId][questionKey] = {
          question: questionLabel,
          answer: answerValue,
        };
      }

      if (answer?.time) {
        newState[formId][activeFormPageId][questionKey].time = answer?.time;
      }
      // Return the updated state
      return newState;
    });
  }

  const clearDependentQuestions = (
    changedQuestionKey,
    tempAnswerList,
    updatedAnswerData,
    updatedJourneyAnswers,
    tempFormAnswer,
    updatedJourneyData
  ) => {
    // Find all questions that depend on the changed question
    const dependentQuestions = [];

    // Check in form schema
    tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
      formPage?.content?.components?.forEach((component) => {
        if (component?.conditional?.when === changedQuestionKey) {
          dependentQuestions.push(component.key);
        }
      });
    });

    // Check in journey schema
    updatedJourneyData?.journey_schema?.screens?.forEach((screen) => {
      screen?.screenPages?.forEach((screenPage) => {
        screenPage?.components?.form?.form_schema?.formData?.forEach(
          (formPage) => {
            formPage?.content?.components?.forEach((component) => {
              if (component?.conditional?.when === changedQuestionKey) {
                dependentQuestions.push(component.key);
              }
            });
          }
        );
      });
    });

    // Remove duplicates
    const uniqueDependentQuestions = [...new Set(dependentQuestions)];

    // For each dependent question, check if it should be hidden and clear if needed
    uniqueDependentQuestions.forEach(async (depQuestionKey) => {
      // Find the question object to check its conditional logic
      let questionObj = null;

      // Search in form schema
      tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
        formPage?.content?.components?.forEach((component) => {
          if (component.key === depQuestionKey) {
            questionObj = component;
          }
        });
      });

      const show = shouldQuestionBeVisible(questionObj, updatedAnswerData);

      if (questionObj && !show) {
        // Clear this question's answer
        clearQuestionAnswer(
          depQuestionKey,
          tempAnswerList,
          updatedAnswerData,
          updatedJourneyAnswers,
          tempFormAnswer,
          updatedJourneyData
        );

        // Recursively clear its dependent questions
        clearDependentQuestions(
          depQuestionKey,
          tempAnswerList,
          updatedAnswerData,
          updatedJourneyAnswers,
          tempFormAnswer,
          updatedJourneyData
        );
      }
    });
  };

  const clearQuestionAnswer = (
    questionKey,
    tempAnswerList,
    updatedAnswerData,
    updatedJourneyAnswers,
    tempFormAnswer,
    updatedJourneyData
  ) => {
    // Remove from tempAnswerList
    const answerIndex = tempAnswerList.findIndex(
      (item) => item.key === questionKey
    );
    if (answerIndex !== -1) {
      tempAnswerList.splice(answerIndex, 1);
    }

    // Remove from updatedAnswerData
    delete updatedAnswerData[questionKey];

    // Remove from updatedJourneyAnswers
    const journeyIndex = updatedJourneyAnswers.findIndex(
      (item) => item.key === questionKey
    );
    if (journeyIndex !== -1) {
      updatedJourneyAnswers.splice(journeyIndex, 1);
    }

    // Clear from form structure
    tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
      formPage?.content?.components?.forEach((component) => {
        if (component.key === questionKey) {
          delete component.answer;
          component.formValidation = false;
        }
      });
    });

    // Clear from journey structure
    updatedJourneyData?.journey_schema?.screens?.forEach((screen) => {
      screen?.screenPages?.forEach((screenPage) => {
        screenPage?.components?.form?.form_schema?.formData?.forEach(
          (formPage) => {
            formPage?.content?.components?.forEach((component) => {
              if (component.key === questionKey) {
                delete component.answer;
                component.formValidation = false;
              }
            });
          }
        );
      });
    });
  };
  const shouldQuestionBeVisible = (questionObj, updatedAnswerData) => {
    if (!questionObj?.conditional?.when || !questionObj?.conditional?.eq) {
      return true; // No conditional logic = always visible
    }

    const dependentAnswer =
      updatedAnswerData[questionObj.conditional.when]?.value;
    const expectedValue = questionObj.conditional.eq;
    const showIfMatch = questionObj.conditional.show || false;

    let matches = false;

    if (
      typeof dependentAnswer === "string" &&
      dependentAnswer === expectedValue
    ) {
      matches = true;
    } else if (
      Array.isArray(dependentAnswer) &&
      dependentAnswer.includes(expectedValue)
    ) {
      matches = true;
    } else if (
      Array.isArray(expectedValue) &&
      typeof dependentAnswer === "string" &&
      expectedValue.includes(dependentAnswer)
    ) {
      matches = true;
    } else if (
      typeof dependentAnswer === "boolean" &&
      dependentAnswer == expectedValue
    ) {
      matches = true;
    } else if (
      typeof dependentAnswer === "object" &&
      dependentAnswer !== null &&
      !Array.isArray(dependentAnswer)
    ) {
      // Handle object format answers like { optionA: true, optionB: false, optionC: true }
      if (
        typeof expectedValue === "string" &&
        dependentAnswer[expectedValue] === true
      ) {
        matches = true;
      } else if (
        Array.isArray(expectedValue) &&
        expectedValue.some((key) => dependentAnswer[key] === true)
      ) {
        matches = true;
      }
    }

    return matches ? showIfMatch : !showIfMatch;
  };

  const checkIfTriggerField = (fieldKey, formStructure) => {
    if (!formStructure) return false;

    const formPages = formStructure?.form_schema?.formData;
    if (!Array.isArray(formPages)) return false;

    for (const page of formPages) {
      const components = page?.content?.components;
      if (components) {
        const allComponents = findAllComponents(components);
        for (const component of allComponents) {
          if (component.logic && Array.isArray(component.logic)) {
            for (const logicRule of component.logic) {
              const condition = logicRule?.trigger?.simple;
              if (condition && condition.when) {
                if (condition.when === fieldKey) {
                  return true;
                }
                if (
                  condition.when.includes(".") &&
                  !condition.when.includes("[")
                ) {
                  const [triggerField] = condition.when.split(".");
                  if (triggerField === fieldKey) {
                    return true;
                  }
                }
              }
            }
          }
        }
      }
    }
    return false;
  };

  const setAnswer = async (question, answer) => {
    if (question?.type === "datetime") {
      if (answer?.value?.$d) {
        const originalDate = new Date(answer?.value?.$d);
        const utcDate = new Date(
          Date.UTC(
            originalDate.getFullYear(),
            originalDate.getMonth(),
            originalDate.getDate(),
            0,
            0,
            0,
            0
          )
        );
        answer.value = utcDate.toISOString();
      }
    }
    if (
      (formData?.formId === "6819ab3ec4f18e73b7d06d0e" ||
        formData?.formId === "685259b64ef9cc55588fb849" ||
        formData?.formId === "686b682dc92b0a640c372127" ||
        formData?.formId === "66fe0d935b3a1419fb71a96d") &&
      question?.key === "patientDepartmentForSchedulerForSpecificForm"
    ) {
      setDepartment_id(answer?.value);
      fetchAllReasons(answer?.value);
    }
    // let tempAnswerList = JSON.parse(JSON.stringify(formattedAnswer?.answers));
    let tempAnswerList = deepCloneWithFiles(formattedAnswer?.answers);
    const questionKey = question?.key;
    addAnswerToTriggerBody(
      formData?.formId,
      activeFormPageId,
      question,
      answer
    );

    if (questionKey === "HBxFirstName") {
      setHBxFirstName(answer?.value);
    }
    if (questionKey === "HBxReasonForVisit") {
      setHBxReasonForVisit(answer?.value);
    }
    if (questionKey === "HBxLastName") {
      setHBxLastName(answer?.value);
    }
    if (questionKey === "HBxEmail") {
      setHBxEmail(answer?.value);
    }
    if (questionKey === "HBxDob") {
      setHBxDob(answer?.value);
    }

    if (questionKey === "preferredTimezoneForAppointmentBooking") {
      setPatientTZ(timezoneMapper[answer?.value]);
    }

    let index = tempAnswerList.findIndex((item) => item.key === questionKey);
    if (index === -1) {
      tempAnswerList.push({
        key: questionKey,
        question: question?.label,
        answer,
      });
    } else {
      tempAnswerList[index].answer = answer;
    }
    setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));

    // let tempFormAnswer = JSON.parse(JSON.stringify(formAnswer));
    let tempFormAnswer = deepCloneWithFiles(formAnswer);
    tempFormAnswer?.form_schema?.formData?.map((formPage) => {
      // formPage?.contents && formPage?.content?.components && formPage?.content?.components.map((item)=>{
      formPage?.content?.components.map((item) => {
        if (item?.key === questionKey) {
          item.answer = answer;
          if (answer && answer?.value) item.formValidation = true;
          else item.formValidation = false;
        }
      });
    });
    setFormAnswer(tempFormAnswer);
    setFormSchema(tempFormAnswer?.form_schema?.formData);

    for (let i = 0; i < tempFormAnswer?.form_schema?.formData?.length; i++) {
      if (tempFormAnswer?.form_schema?.formData[i].id === activeFormPageId) {
        setActiveFormPage(tempFormAnswer?.form_schema?.formData[i]?.content);
      }
    }

    // let updatedAnswerData = JSON.parse(JSON.stringify(answerData));
    let updatedAnswerData = deepCloneWithFiles(answerData);
    updatedAnswerData[questionKey] = answer;
    setAnswerData(updatedAnswerData);
    // console.log(tempFormAnswer);

    let updatedJourneyAnswers = JSON.parse(
      JSON.stringify(completeJourneyAnswers)
    );
    let indexJourneyAnswer = updatedJourneyAnswers.findIndex(
      (item) => item.key === questionKey
    );
    if (indexJourneyAnswer === -1) {
      updatedJourneyAnswers.push({
        key: questionKey,
        question: question?.label,
        answer,
      });
    } else {
      updatedJourneyAnswers[indexJourneyAnswer].answer = answer;
    }
    setCompleteJourneyAnswers(updatedJourneyAnswers);

    // let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let updatedJourneyData = deepCloneWithFiles(journeyData);

    let screens = updatedJourneyData?.journey_schema?.screens;

    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (screenPages[j]?.id === activeScreenPageID) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              if (form[idx]?.id === activeFormPageId) {
                let formContent = form[idx]?.content?.components;
                formContent?.map((ques) => {
                  if (ques?.key === questionKey) ques.answer = answer;
                  if (answer && answer?.value) ques.formValidation = true;
                  else ques.formValidation = false;
                });
              }
            }
          }
        }
      }
    }
    setJourneyData(updatedJourneyData);

    // Clear dependent questions if this answer change affects conditional logic
    clearDependentQuestions(
      questionKey,
      tempAnswerList,
      updatedAnswerData,
      updatedJourneyAnswers,
      tempFormAnswer,
      updatedJourneyData
    );

    const iDontWantToAddMyCardOnFile =
      updatedAnswerData?.["iDontWantToAddMyCardOnFile"]?.value == true;
    if (
      !iDontWantToAddMyCardOnFile &&
      questionKey === "selectHowSynaptrxSleepCanUseYourCardOnFile"
    ) {
      const UseYourCardOnFile =
        updatedAnswerData?.selectHowSynaptrxSleepCanUseYourCardOnFile?.value ||
        "";
      if (UseYourCardOnFile) {
        const API_URL = process.env.REACT_APP_SCHEDULER_URL;
        const paymentUploadUrl =
          UseYourCardOnFile === "singleAppointment"
            ? `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/singleappointment`
            : `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/oneyear`;
        await callAthenaGetApi(paymentUploadUrl);
      }
    }
    // if (
    //   (formData?.formId === "67f7cb7393a8e4fac0461c2e" ||
    //     formData?.formId === "680b7a141b878c3e8f5b5072" ||
    //     formData?.formId === "685cf4f79689d33502580753" ||
    //     formData?.formId === "685cf5dd60c6b60a7aadfa83" ||
    //     formData?.formId === "67fe43741b878c3e8f5b33d0" ||
    //     formData?.formId === "6870f8ace3e9c17d11fcf510" ||
    //     formData?.formId === "6836ed5866e091a6310b50b0") &&
    //   (question?.key === "heightInches" || question?.key === "weightLbs")
    // ) {
    //   // Use the updated answerData to get current values
    //   const heightInches =
    //     question?.key === "heightInches"
    //       ? answer?.value
    //       : updatedAnswerData?.heightInches?.value;
    //   const weightLbs =
    //     question?.key === "weightLbs"
    //       ? answer?.value
    //       : updatedAnswerData?.weightLbs?.value;

    //   // Add validation to ensure both values are valid numbers and reasonable
    //   const isValidHeight =
    //     heightInches &&
    //     !isNaN(heightInches) &&
    //     parseFloat(heightInches) > 0 &&
    //     parseFloat(heightInches) <= 120; // reasonable height range
    //   const isValidWeight =
    //     weightLbs &&
    //     !isNaN(weightLbs) &&
    //     parseFloat(weightLbs) > 0 &&
    //     parseFloat(weightLbs) <= 1000; // reasonable weight range

    //   if (isValidHeight && isValidWeight) {
    //     const heightNum = parseFloat(heightInches);
    //     const weightNum = parseFloat(weightLbs);

    //     const calculatedBMI = (
    //       (weightNum / (heightNum * heightNum)) *
    //       703
    //     ).toFixed(2);

    //     // Only proceed if BMI calculation results in a reasonable value
    //     if (
    //       !isNaN(calculatedBMI) &&
    //       parseFloat(calculatedBMI) > 0 &&
    //       parseFloat(calculatedBMI) < 200
    //     ) {
    //       // Directly update the form data structures instead of calling setAnswer recursively
    //       const bmiAnswer = { value: calculatedBMI };
    //       const bmiQuestion = {
    //         label: "BMI",
    //         key: "bmi",
    //         type: "textfield",
    //       };

    //       // Update tempAnswerList
    //       let bmiIndex = tempAnswerList.findIndex((item) => item.key === "bmi");
    //       if (bmiIndex === -1) {
    //         tempAnswerList.push({
    //           key: "bmi",
    //           question: "BMI",
    //           answer: bmiAnswer,
    //         });
    //       } else {
    //         tempAnswerList[bmiIndex].answer = bmiAnswer;
    //       }

    //       // Update updatedAnswerData
    //       updatedAnswerData["bmi"] = bmiAnswer;

    //       // Update journey answers
    //       let bmijourneyIndex = updatedJourneyAnswers.findIndex(
    //         (item) => item.key === "bmi"
    //       );
    //       if (bmijourneyIndex === -1) {
    //         updatedJourneyAnswers.push({
    //           key: "bmi",
    //           question: "BMI",
    //           answer: bmiAnswer,
    //         });
    //       } else {
    //         updatedJourneyAnswers[bmijourneyIndex].answer = bmiAnswer;
    //       }

    //       // Update form structure
    //       tempFormAnswer?.form_schema?.formData?.map((formPage) => {
    //         formPage?.content?.components.map((item) => {
    //           if (item?.key === "bmi") {
    //             item.answer = bmiAnswer;
    //             item.formValidation = true;
    //           }
    //         });
    //       });

    //       // Update journey data structure
    //       for (let i = 0; i < screens?.length; i++) {
    //         if (screens[i]?.id === activeScreenID) {
    //           let screenPages = screens[i]?.screenPages;
    //           for (let j = 0; j < screenPages?.length; j++) {
    //             if (screenPages[j]?.id === activeScreenPageID) {
    //               let form =
    //                 screenPages[j]?.components?.form?.form_schema?.formData;
    //               for (let idx = 0; idx < form?.length; idx++) {
    //                 if (form[idx]?.id === activeFormPageId) {
    //                   let formContent = form[idx]?.content?.components;
    //                   formContent?.map((ques) => {
    //                     if (ques?.key === "bmi") {
    //                       ques.answer = bmiAnswer;
    //                       ques.formValidation = true;
    //                     }
    //                   });
    //                 }
    //               }
    //             }
    //           }
    //         }
    //       }

    //       // Add to trigger body
    //       addAnswerToTriggerBody(
    //         formData?.formId,
    //         activeFormPageId,
    //         bmiQuestion,
    //         bmiAnswer
    //       );

    //       if (parseFloat(calculatedBMI) >= 30) {
    //         const qAnswer = { value: "Yes" };
    //         const questionToUpdate = {
    //           label: "Is BMI Greater than or Equal to 30?",
    //           key: "isBmiGreaterThanOrEqualTo30",
    //           type: "radio",
    //         };
    //         // Update tempAnswerList
    //         let questionIndex = tempAnswerList.findIndex(
    //           (item) => item.key === questionToUpdate?.key
    //         );
    //         if (questionIndex === -1) {
    //           tempAnswerList.push({
    //             key: questionToUpdate?.key,
    //             question: questionToUpdate?.label,
    //             answer: qAnswer,
    //           });
    //         } else {
    //           tempAnswerList[questionIndex].answer = qAnswer;
    //         }

    //         // Update updatedAnswerData
    //         updatedAnswerData[questionToUpdate?.key] = qAnswer;

    //         // Update journey answers
    //         let quesjourneyIndex = updatedJourneyAnswers.findIndex(
    //           (item) => item.key === questionToUpdate?.key
    //         );
    //         if (quesjourneyIndex === -1) {
    //           updatedJourneyAnswers.push({
    //             key: questionToUpdate?.key,
    //             question: questionToUpdate?.label,
    //             answer: qAnswer,
    //           });
    //         } else {
    //           updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
    //         }

    //         // Update form structure
    //         tempFormAnswer?.form_schema?.formData?.map((formPage) => {
    //           formPage?.content?.components.map((item) => {
    //             if (item?.key === questionToUpdate?.key) {
    //               item.answer = qAnswer;
    //               item.formValidation = true;
    //             }
    //           });
    //         });

    //         // Update journey data structure
    //         let activeFormPageIdForThisData = null;
    //         let activeFormIdForThisData = null;
    //         for (let i = 0; i < screens?.length; i++) {
    //           let screenPages = screens[i]?.screenPages;
    //           for (let j = 0; j < screenPages?.length; j++) {
    //             let form =
    //               screenPages[j]?.components?.form?.form_schema?.formData;
    //             for (let idx = 0; idx < form?.length; idx++) {
    //               let formContent = form[idx]?.content?.components;
    //               formContent?.map((ques) => {
    //                 if (ques?.key === questionToUpdate?.key) {
    //                   activeFormPageIdForThisData = form[idx]?.id;
    //                   activeFormIdForThisData =
    //                     screenPages[j]?.components?.formId;
    //                   ques.answer = qAnswer;
    //                   ques.formValidation = true;
    //                 }
    //               });
    //             }
    //           }
    //         }

    //         // Add to trigger body
    //         addAnswerToTriggerBody(
    //           activeFormIdForThisData,
    //           activeFormPageIdForThisData,
    //           questionToUpdate,
    //           qAnswer
    //         );
    //       } else {
    //         const qAnswer = { value: "No" };
    //         const questionToUpdate = {
    //           label: "Is BMI Greater than or Equal to 30?",
    //           key: "isBmiGreaterThanOrEqualTo30",
    //           type: "radio",
    //         };
    //         // Update tempAnswerList
    //         let questionIndex = tempAnswerList.findIndex(
    //           (item) => item.key === questionToUpdate?.key
    //         );
    //         if (questionIndex === -1) {
    //           tempAnswerList.push({
    //             key: questionToUpdate?.key,
    //             question: questionToUpdate?.label,
    //             answer: qAnswer,
    //           });
    //         } else {
    //           tempAnswerList[questionIndex].answer = qAnswer;
    //         }

    //         // Update updatedAnswerData
    //         updatedAnswerData[questionToUpdate?.key] = qAnswer;

    //         // Update journey answers
    //         let quesjourneyIndex = updatedJourneyAnswers.findIndex(
    //           (item) => item.key === questionToUpdate?.key
    //         );
    //         if (quesjourneyIndex === -1) {
    //           updatedJourneyAnswers.push({
    //             key: questionToUpdate?.key,
    //             question: questionToUpdate?.label,
    //             answer: qAnswer,
    //           });
    //         } else {
    //           updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
    //         }

    //         // Update form structure
    //         tempFormAnswer?.form_schema?.formData?.map((formPage) => {
    //           formPage?.content?.components.map((item) => {
    //             if (item?.key === questionToUpdate?.key) {
    //               item.answer = qAnswer;
    //               item.formValidation = true;
    //             }
    //           });
    //         });

    //         // Update journey data structure
    //         let activeFormPageIdForThisData = null;
    //         let activeFormIdForThisData = null;
    //         for (let i = 0; i < screens?.length; i++) {
    //           let screenPages = screens[i]?.screenPages;
    //           for (let j = 0; j < screenPages?.length; j++) {
    //             let form =
    //               screenPages[j]?.components?.form?.form_schema?.formData;
    //             for (let idx = 0; idx < form?.length; idx++) {
    //               let formContent = form[idx]?.content?.components;
    //               formContent?.map((ques) => {
    //                 if (ques?.key === questionToUpdate?.key) {
    //                   activeFormPageIdForThisData = form[idx]?.id;
    //                   activeFormIdForThisData =
    //                     screenPages[j]?.components?.formId;
    //                   ques.answer = qAnswer;
    //                   ques.formValidation = true;
    //                 }
    //               });
    //             }
    //           }
    //         }

    //         // Add to trigger body
    //         addAnswerToTriggerBody(
    //           activeFormIdForThisData,
    //           activeFormPageIdForThisData,
    //           questionToUpdate,
    //           qAnswer
    //         );
    //       }

    //       // Re-apply the state updates with BMI included
    //       setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
    //       setAnswerData(updatedAnswerData);
    //       setCompleteJourneyAnswers(updatedJourneyAnswers);
    //       setFormAnswer(tempFormAnswer);
    //       setFormSchema(tempFormAnswer?.form_schema?.formData);
    //       setJourneyData(updatedJourneyData);
    //     }
    //   } else {
    //     // If either value is invalid, set BMI to null everywhere
    //     console.log("Invalid height or weight values - setting BMI to null");

    //     const bmiAnswer = { value: "" };
    //     const bmiQuestion = {
    //       label: "BMI",
    //       key: "bmi",
    //       type: "textfield",
    //     };

    //     // Update tempAnswerList with null BMI
    //     let bmiIndex = tempAnswerList.findIndex((item) => item.key === "bmi");
    //     if (bmiIndex === -1) {
    //       tempAnswerList.push({
    //         key: "bmi",
    //         question: "BMI",
    //         answer: bmiAnswer,
    //       });
    //     } else {
    //       tempAnswerList[bmiIndex].answer = bmiAnswer;
    //     }

    //     // Update updatedAnswerData with null BMI
    //     updatedAnswerData["bmi"] = bmiAnswer;

    //     // Update journey answers with null BMI
    //     let bmijourneyIndex = updatedJourneyAnswers.findIndex(
    //       (item) => item.key === "bmi"
    //     );
    //     if (bmijourneyIndex === -1) {
    //       updatedJourneyAnswers.push({
    //         key: "bmi",
    //         question: "BMI",
    //         answer: bmiAnswer,
    //       });
    //     } else {
    //       updatedJourneyAnswers[bmijourneyIndex].answer = bmiAnswer;
    //     }

    //     // Set BMI to null in form structures
    //     tempFormAnswer?.form_schema?.formData?.map((formPage) => {
    //       formPage?.content?.components.map((item) => {
    //         if (item?.key === "bmi") {
    //           item.answer = bmiAnswer;
    //           item.formValidation = false;
    //         }
    //       });
    //     });

    //     // Set BMI to null in journey data structure
    //     for (let i = 0; i < screens?.length; i++) {
    //       if (screens[i]?.id === activeScreenID) {
    //         let screenPages = screens[i]?.screenPages;
    //         for (let j = 0; j < screenPages?.length; j++) {
    //           if (screenPages[j]?.id === activeScreenPageID) {
    //             let form =
    //               screenPages[j]?.components?.form?.form_schema?.formData;
    //             for (let idx = 0; idx < form?.length; idx++) {
    //               if (form[idx]?.id === activeFormPageId) {
    //                 let formContent = form[idx]?.content?.components;
    //                 formContent?.map((ques) => {
    //                   if (ques?.key === "bmi") {
    //                     ques.answer = bmiAnswer;
    //                     ques.formValidation = false;
    //                   }
    //                 });
    //               }
    //             }
    //           }
    //         }
    //       }
    //     }

    //     // Add null BMI to trigger body
    //     addAnswerToTriggerBody(
    //       formData?.formId,
    //       activeFormPageId,
    //       bmiQuestion,
    //       bmiAnswer
    //     );

    //     // Update states with null BMI
    //     setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
    //     setAnswerData(updatedAnswerData);
    //     setCompleteJourneyAnswers(updatedJourneyAnswers);
    //     setFormAnswer(tempFormAnswer);
    //     setFormSchema(tempFormAnswer?.form_schema?.formData);
    //     setJourneyData(updatedJourneyData);
    //   }
    // }
    if (
      (formData?.formId === "67f7cb7393a8e4fac0461c2e" ||
        formData?.formId === "680b7a141b878c3e8f5b5072" ||
        formData?.formId === "685cf4f79689d33502580753" ||
        formData?.formId === "685cf5dd60c6b60a7aadfa83" ||
        formData?.formId === "67fe43741b878c3e8f5b33d0" ||
        formData?.formId === "6870f8ace3e9c17d11fcf510" ||
        formData?.formId === "6836ed5866e091a6310b50b0") &&
      (question?.key === "heightInches" || question?.key === "weightLbs")
    ) {
      // Get current height and weight values
      const heightInches =
        question?.key === "heightInches"
          ? answer?.value
          : updatedAnswerData?.heightInches?.value;

      const weightLbs =
        question?.key === "weightLbs"
          ? answer?.value
          : updatedAnswerData?.weightLbs?.value;

      // Helper function to validate numeric input
      const isValidNumber = (value, min = 0, max = Infinity) => {
        const num = parseFloat(value);
        return value && !isNaN(num) && num > min && num <= max;
      };

      // Validate inputs
      const isValidHeight = isValidNumber(heightInches, 0, 120);
      const isValidWeight = isValidNumber(weightLbs, 0, 1000);

      // Helper function to update answer in all data structures
      const updateAnswerInStructures = (
        key,
        question,
        answer,
        isValid = true
      ) => {
        // Update tempAnswerList
        const existingIndex = tempAnswerList.findIndex(
          (item) => item.key === key
        );
        const answerItem = { key, question, answer };

        if (existingIndex === -1) {
          tempAnswerList.push(answerItem);
        } else {
          tempAnswerList[existingIndex].answer = answer;
        }

        // Update updatedAnswerData
        updatedAnswerData[key] = answer;

        // Update journey answers
        const journeyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === key
        );
        if (journeyIndex === -1) {
          updatedJourneyAnswers.push(answerItem);
        } else {
          updatedJourneyAnswers[journeyIndex].answer = answer;
        }

        // Update form structure - use forEach instead of map for side effects
        tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
          formPage?.content?.components?.forEach((item) => {
            if (item?.key === key) {
              item.answer = answer;
              item.formValidation = isValid;
            }
          });
        });

        // Update journey data structure and find form IDs
        let targetFormId = null;
        let targetFormPageId = null;

        screens?.forEach((screen) => {
          if (screen?.id === activeScreenID) {
            screen?.screenPages?.forEach((screenPage) => {
              if (screenPage?.id === activeScreenPageID) {
                const form =
                  screenPage?.components?.form?.form_schema?.formData;
                form?.forEach((formPageItem) => {
                  if (formPageItem?.id === activeFormPageId) {
                    formPageItem?.content?.components?.forEach((ques) => {
                      if (ques?.key === key) {
                        if (!targetFormId)
                          targetFormId = screenPage?.components?.formId;
                        if (!targetFormPageId)
                          targetFormPageId = formPageItem?.id;
                        ques.answer = answer;
                        ques.formValidation = isValid;
                      }
                    });
                  }
                });
              }
            });
          }
        });

        // Add to trigger body
        addAnswerToTriggerBody(
          targetFormId || formData?.formId,
          targetFormPageId || activeFormPageId,
          { label: question, key, type: key === "bmi" ? "textfield" : "radio" },
          answer
        );
      };

      if (isValidHeight && isValidWeight) {
        const heightNum = parseFloat(heightInches);
        const weightNum = parseFloat(weightLbs);
        const calculatedBMI = (
          (weightNum / (heightNum * heightNum)) *
          703
        ).toFixed(2);

        // Validate calculated BMI
        if (isValidNumber(calculatedBMI, 0, 200)) {
          const bmiAnswer = { value: calculatedBMI };

          // Update BMI field
          updateAnswerInStructures("bmi", "BMI", bmiAnswer, true);

          // Update BMI threshold question based on calculated value
          const bmiThresholdAnswer = {
            value: parseFloat(calculatedBMI) >= 30 ? "Yes" : "No",
          };
          updateAnswerInStructures(
            "isBmiGreaterThanOrEqualTo30",
            "Is BMI Greater than or Equal to 30?",
            bmiThresholdAnswer,
            true
          );
        } else {
          console.warn("Calculated BMI is invalid:", calculatedBMI);
        }
      } else {
        // Handle invalid height/weight - clear BMI values
        const emptyAnswer = { value: "" };

        // Clear BMI field
        updateAnswerInStructures("bmi", "BMI", emptyAnswer, false);

        // Clear BMI threshold question
        updateAnswerInStructures(
          "isBmiGreaterThanOrEqualTo30",
          "Is BMI Greater than or Equal to 30?",
          emptyAnswer,
          false
        );
      }

      // Apply all state updates once at the end
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }
    if (
      (formData?.formId === "689c1758af230220db3f8d92" ||
        formData?.formId === "689afb02e329f8c3d0964122") &&
      question?.key === "procedures"
    ) {
      // SuperBill Charges Calculation
      const calculatedTotals = {
        totalCharges: 0,
        totalPaid: 0,
        totalDue: 0,
      };

      // Helper function to safely parse float values
      const safeParseFloat = (value, defaultValue = 0) => {
        const parsed = parseFloat(value || 0);
        return isNaN(parsed) ? defaultValue : parsed;
      };

      // Recursive function to find and calculate procedure totals
      const findAndCalculateProcedureTotals = (components) => {
        if (!Array.isArray(components)) return;

        components.forEach((component) => {
          // Check if this is the procedures component
          if (
            component?.key === "procedures" &&
            component?.type === "datagrid" &&
            Array.isArray(component?.answer?.value)
          ) {
            // Calculate totals from procedure data
            component.answer.value.forEach((procedure) => {
              calculatedTotals.totalCharges += safeParseFloat(procedure?.fees);
              calculatedTotals.totalPaid += safeParseFloat(
                procedure?.amountPaid
              );
              calculatedTotals.totalDue += safeParseFloat(procedure?.amountDue);
            });
          }

          // Recursively check nested components
          if (Array.isArray(component?.components)) {
            findAndCalculateProcedureTotals(component.components);
          }
        });
      };

      // Helper function to update total field answers in all data structures
      const updateTotalFieldInStructures = (fieldKey, calculatedValue) => {
        const answer = { value: calculatedValue.toString() };
        const question = fieldKey
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase()); // Convert camelCase to Title Case

        // Update tempAnswerList
        const existingIndex = tempAnswerList.findIndex(
          (item) => item.key === fieldKey
        );
        const answerItem = { key: fieldKey, question, answer };

        if (existingIndex === -1) {
          tempAnswerList.push(answerItem);
        } else {
          tempAnswerList[existingIndex] = answerItem;
        }

        // Update updatedAnswerData
        updatedAnswerData[fieldKey] = answer;

        // Update journey answers
        const journeyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === fieldKey
        );
        if (journeyIndex === -1) {
          updatedJourneyAnswers.push(answerItem);
        } else {
          updatedJourneyAnswers[journeyIndex] = answerItem;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
          formPage?.content?.components?.forEach((component) => {
            if (component?.key === fieldKey) {
              if (!component.answer) component.answer = {};
              component.answer.value = calculatedValue.toString();
              component.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let targetFormId = null;
        let targetFormPageId = null;

        screens?.forEach((screen) => {
          screen?.screenPages?.forEach((screenPage) => {
            const form = screenPage?.components?.form?.form_schema?.formData;
            form?.forEach((formPageItem) => {
              formPageItem?.content?.components?.forEach((component) => {
                if (component?.key === fieldKey) {
                  if (!targetFormId)
                    targetFormId = screenPage?.components?.formId;
                  if (!targetFormPageId) targetFormPageId = formPageItem?.id;

                  if (!component.answer) component.answer = {};
                  component.answer.value = calculatedValue.toString();
                  component.formValidation = true;
                }
              });
            });
          });
        });

        // Add to trigger body
        addAnswerToTriggerBody(
          targetFormId || formData?.formId,
          targetFormPageId || activeFormPageId,
          { label: question, key: fieldKey, type: "textfield" },
          answer
        );
      };

      // Process all form pages to find procedure information
      const formPages = tempFormAnswer?.form_schema?.formData;
      if (Array.isArray(formPages)) {
        // Calculate totals from procedure information
        formPages.forEach((page) => {
          const components = page?.content?.components;
          if (components) {
            findAndCalculateProcedureTotals(components);
          }
        });

        // Update all total fields with calculated values
        updateTotalFieldInStructures(
          "totalCharges",
          calculatedTotals.totalCharges
        );
        updateTotalFieldInStructures("totalPaid", calculatedTotals.totalPaid);
        updateTotalFieldInStructures("totalDue", calculatedTotals.totalDue);
      }

      // Apply all state updates once at the end
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }

    if (
      formData?.formId === "682ee8aa1b878c3e8f5ba664" &&
      question?.key === "screeningConsentPatientSignature"
    ) {
      // Use the updated answerData to get current values
      const screeningConsentPatientSignature = answer?.value;

      // Add validation to ensure both values are valid numbers and reasonable
      const isValidAnswer =
        screeningConsentPatientSignature &&
        screeningConsentPatientSignature !== "" &&
        screeningConsentPatientSignature !== null;

      if (isValidAnswer) {
        const consentAnswer = { value: "Yes" };
        const consentQuestion = {
          label: "Consent(s) signed?",
          key: "consentSSigned",
          type: "radio",
        };

        // Update tempAnswerList
        let consentIndex = tempAnswerList.findIndex(
          (item) => item.key === consentQuestion?.key
        );
        if (consentIndex === -1) {
          tempAnswerList.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          tempAnswerList[consentIndex].answer = consentAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[consentQuestion?.key] = consentAnswer;

        // Update journey answers
        let consentjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === consentQuestion?.key
        );
        if (consentjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          updatedJourneyAnswers[consentjourneyIndex].answer = consentAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === consentQuestion?.key) {
              item.answer = consentAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === consentQuestion?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = consentAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          consentQuestion,
          consentAnswer
        );

        // Re-apply the state updates with BMI included
        setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
        setAnswerData(updatedAnswerData);
        setCompleteJourneyAnswers(updatedJourneyAnswers);
        setFormAnswer(tempFormAnswer);
        setFormSchema(tempFormAnswer?.form_schema?.formData);
        setJourneyData(updatedJourneyData);
      } else {
        const consentAnswer = { value: "No" };
        const consentQuestion = {
          label: "Consent(s) signed?",
          key: "consentSSigned",
          type: "radio",
        };

        // Update tempAnswerList
        let consentIndex = tempAnswerList.findIndex(
          (item) => item.key === consentQuestion?.key
        );
        if (consentIndex === -1) {
          tempAnswerList.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          tempAnswerList[consentIndex].answer = consentAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[consentQuestion?.key] = consentAnswer;

        // Update journey answers
        let consentjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === consentQuestion?.key
        );
        if (consentjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          updatedJourneyAnswers[consentjourneyIndex].answer = consentAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === consentQuestion?.key) {
              item.answer = consentAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === consentQuestion?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = consentAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          consentQuestion,
          consentAnswer
        );

        // Re-apply the state updates with BMI included
        setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
        setAnswerData(updatedAnswerData);
        setCompleteJourneyAnswers(updatedJourneyAnswers);
        setFormAnswer(tempFormAnswer);
        setFormSchema(tempFormAnswer?.form_schema?.formData);
        setJourneyData(updatedJourneyData);
      }
    }

    if (
      formData?.formId === "67f7cb7393a8e4fac0461c2e" &&
      (question?.key === "neckCircumferenceInches" ||
        question?.key === "gender" ||
        question?.key === "bmi")
    ) {
      if (
        question?.key === "neckCircumferenceInches" ||
        question?.key === "gender"
      ) {
        const gender =
          question?.key === "gender"
            ? answer?.value
            : updatedAnswerData?.gender?.value;
        const neckCircumferenceInches =
          question?.key === "neckCircumferenceInches"
            ? answer?.value
            : updatedAnswerData?.neckCircumferenceInches?.value;

        let cirmuferenceIsGreater = false;
        if (gender === "male" && parseFloat(neckCircumferenceInches) >= 17) {
          cirmuferenceIsGreater = true;
        }
        if (gender === "female" && parseFloat(neckCircumferenceInches) >= 15) {
          cirmuferenceIsGreater = true;
        }
        let qAnswer = null;
        if (cirmuferenceIsGreater) {
          qAnswer = { value: "Yes" };
        } else {
          qAnswer = { value: "No" };
        }
        const questionToUpdate = {
          label: "Is Neck Circumference > 17' (Men) or > 15' (Women)?",
          key: "isNeckCircumference17MenOr15Women",
          type: "radio",
        };
        let questionIndex = tempAnswerList.findIndex(
          (item) => item.key === questionToUpdate?.key
        );
        if (questionIndex === -1) {
          tempAnswerList.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          tempAnswerList[questionIndex].answer = qAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[questionToUpdate?.key] = qAnswer;

        // Update journey answers
        let quesjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === questionToUpdate?.key
        );
        if (quesjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === questionToUpdate?.key) {
              item.answer = qAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === questionToUpdate?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = qAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          questionToUpdate,
          qAnswer
        );
      }
      if (question?.key === "bmi") {
        const bmiValue = answer?.value;
        let qAnswer = null;
        if (parseFloat(bmiValue) >= 30) {
          qAnswer = { value: "Yes" };
        } else {
          qAnswer = { value: "No" };
        }
        const questionToUpdate = {
          label: "Is BMI Greater than or Equal to 30?",
          key: "isBmiGreaterThanOrEqualTo30",
          type: "radio",
        };
        let questionIndex = tempAnswerList.findIndex(
          (item) => item.key === questionToUpdate?.key
        );
        if (questionIndex === -1) {
          tempAnswerList.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          tempAnswerList[questionIndex].answer = qAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[questionToUpdate?.key] = qAnswer;

        // Update journey answers
        let quesjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === questionToUpdate?.key
        );
        if (quesjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === questionToUpdate?.key) {
              item.answer = qAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === questionToUpdate?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = qAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          questionToUpdate,
          qAnswer
        );
      }

      // Re-apply the state updates with BMI included
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }

    // Enhanced Compare values with type coercion
    const compareValues = (value1, value2) => {
      // Handle arrays (for multi-select components)
      if (Array.isArray(value1) && Array.isArray(value2)) {
        return JSON.stringify(value1.sort()) === JSON.stringify(value2.sort());
      }

      if (Array.isArray(value1)) {
        return value1.includes(value2);
      }

      if (Array.isArray(value2)) {
        return value2.includes(value1);
      }

      // Handle objects
      if (typeof value1 === "object" && typeof value2 === "object") {
        return JSON.stringify(value1) === JSON.stringify(value2);
      }

      // Convert to string for comparison
      return String(value1) === String(value2);
    };

    // Enhanced field value getter with comprehensive datagrid support
    const getFieldValue = (
      fieldKey,
      formData = {},
      currentRowData = null,
      currentRowIndex = null
    ) => {
      // Handle dot notation for nested fields
      if (fieldKey.includes(".")) {
        const keys = fieldKey.split(".");
        let value = formData;

        for (const key of keys) {
          if (value && typeof value === "object") {
            value = value[key];
          } else {
            return null;
          }
        }

        return value;
      }

      // If we're in a datagrid context and the field exists in current row
      if (currentRowData && currentRowData.hasOwnProperty(fieldKey)) {
        return currentRowData[fieldKey];
      }

      // Check for datagrid field pattern (e.g., "procedures[0].cptCode")
      const datagridPattern = /^(\w+)\[(\d+)\]\.(\w+)$/;
      const match = fieldKey.match(datagridPattern);

      if (match) {
        const [, datagridKey, rowIndex, columnKey] = match;
        const datagridData = formData[datagridKey];

        if (Array.isArray(datagridData) && datagridData[parseInt(rowIndex)]) {
          return datagridData[parseInt(rowIndex)][columnKey];
        }
      }

      // Direct field access
      return formData[fieldKey];
    };

    // Enhanced condition evaluation with dynamic datagrid pattern support
    const evaluateCondition = (
      condition,
      allValues,
      currentRowData = null,
      currentRowIndex = null,
      datagridKey = null
    ) => {
      const {
        show = true,
        when,
        eq,
        neq,
        gt,
        lt,
        gte,
        lte,
        in: inArray,
        nin,
      } = condition;

      if (!when) return show; // Default to show if no condition

      let triggerValue;

      // Handle datagrid patterns like "procedures.cptCode"
      if (when.includes(".") && !when.includes("[")) {
        const [possibleDatagridKey, fieldKey] = when.split(".", 2);

        // If we're in a datagrid context and the trigger references this datagrid
        if (currentRowData !== null && datagridKey === possibleDatagridKey) {
          triggerValue = currentRowData[fieldKey];
        } else {
          // Try to find the value in the global form data
          const datagridData = allValues[possibleDatagridKey];
          if (
            Array.isArray(datagridData) &&
            currentRowIndex !== null &&
            datagridData[currentRowIndex]
          ) {
            triggerValue = datagridData[currentRowIndex][fieldKey];
          } else {
            // Fallback to global value lookup
            triggerValue = getFieldValue(
              when,
              allValues,
              currentRowData,
              currentRowIndex
            );
          }
        }
      }
      // Handle direct field references in datagrid context
      else if (currentRowData !== null && datagridKey) {
        // First try to get value from current row
        triggerValue = getFieldValue(
          when,
          allValues,
          currentRowData,
          currentRowIndex
        );

        // If not found in current row, try global form values
        if (triggerValue === null || triggerValue === undefined) {
          triggerValue = getFieldValue(when, allValues);
        }

        // If still not found, try with datagrid prefix
        if (triggerValue === null || triggerValue === undefined) {
          const datagridFieldKey = `${datagridKey}[${currentRowIndex}].${when}`;
          triggerValue = getFieldValue(datagridFieldKey, allValues);
        }
      } else {
        triggerValue = getFieldValue(
          when,
          allValues,
          currentRowData,
          currentRowIndex
        );
      }

      // Handle different condition types
      if (eq !== undefined) {
        return compareValues(triggerValue, eq);
      }

      if (neq !== undefined) {
        return !compareValues(triggerValue, neq);
      }

      if (gt !== undefined) {
        return parseFloat(triggerValue || 0) > parseFloat(gt);
      }

      if (lt !== undefined) {
        return parseFloat(triggerValue || 0) < parseFloat(lt);
      }

      if (gte !== undefined) {
        return parseFloat(triggerValue || 0) >= parseFloat(gte);
      }

      if (lte !== undefined) {
        return parseFloat(triggerValue || 0) <= parseFloat(lte);
      }

      if (inArray !== undefined) {
        return Array.isArray(inArray) && inArray.includes(triggerValue);
      }

      if (nin !== undefined) {
        return Array.isArray(nin) && !nin.includes(triggerValue);
      }

      // Default: check if trigger value is truthy
      return Boolean(triggerValue);
    };

    // Enhanced logic action execution
    const executeLogicAction = (
      action,
      targetComponent,
      allValues,
      currentRowData = null
    ) => {
      const { type, name, value: actionValue } = action;

      switch (type) {
        case "value":
          // Parse and execute value assignment
          if (actionValue && actionValue.startsWith("value = ")) {
            const newValue = actionValue.replace("value = ", "").trim();

            // Handle different value types
            let parsedValue = newValue;

            // Remove quotes if it's a string literal
            if (newValue.startsWith('"') && newValue.endsWith('"')) {
              parsedValue = newValue.slice(1, -1);
            } else if (newValue.startsWith("'") && newValue.endsWith("'")) {
              parsedValue = newValue.slice(1, -1);
            } else if (!isNaN(newValue)) {
              // Convert to number if it's numeric
              parsedValue = parseFloat(newValue);
            } else if (newValue === "true" || newValue === "false") {
              // Convert to boolean
              parsedValue = newValue === "true";
            }

            return parsedValue;
          }
          break;

        case "property":
          // Handle property changes (like disabled, hidden, etc.)
          return actionValue;

        case "customAction":
          // Handle custom actions
          if (typeof actionValue === "function") {
            return actionValue(targetComponent, allValues, currentRowData);
          }
          break;

        default:
          return actionValue;
      }

      return null;
    };

    // Enhanced form values getter with datagrid support
    const getAllFormValues = () => {
      const allValues = {};

      // Extract values from tempAnswerList
      if (Array.isArray(tempAnswerList)) {
        tempAnswerList.forEach((item) => {
          if (item.key && item.answer && item.answer.value !== undefined) {
            allValues[item.key] = item.answer.value;
          }
        });
      }

      // Extract values from updatedAnswerData
      Object.keys(updatedAnswerData || {}).forEach((key) => {
        if (
          updatedAnswerData[key] &&
          updatedAnswerData[key].value !== undefined
        ) {
          allValues[key] = updatedAnswerData[key].value;
        }
      });

      return allValues;
    };

    // Simplified and more reliable trigger matching function
    const doesTriggerMatchChangedField = (
      triggerWhen,
      changedFieldKey,
      changedColumnKey,
      currentDatagridKey
    ) => {
      // Direct exact match
      if (triggerWhen === changedFieldKey) {
        return true;
      }

      // If we're dealing with a datagrid field change
      if (currentDatagridKey && changedColumnKey) {
        // Pattern: "datagridKey.columnKey" should match when "datagridKey[index].columnKey" changes
        const expectedPattern = `${currentDatagridKey}.${changedColumnKey}`;
        if (triggerWhen === expectedPattern) {
          return true;
        }

        // Pattern: Direct column name match within same datagrid context
        if (triggerWhen === changedColumnKey) {
          return true;
        }
      }
      return false;
    };

    // Enhanced main logic processing function with fixed datagrid support
    const processFormLogic = (changedFieldKey, changedValue, answerMetadata = {}) => {
      const allValues = getAllFormValues();
      // Update the changed value in our evaluation context
      allValues[changedFieldKey] = changedValue;

      // Handle datagrid updates - if the changed field is a datagrid array,
      // we need to process logic for each individual field that might have changed
      const isDatagridUpdate =
        Array.isArray(changedValue) && !changedFieldKey.includes("[");

      if (isDatagridUpdate) {
        // If metadata indicates which specific field was edited, only process that field
        if (answerMetadata.editedFieldKey !== undefined && answerMetadata.editedRowIndex !== undefined) {
          const individualFieldKey = `${changedFieldKey}[${answerMetadata.editedRowIndex}].${answerMetadata.editedFieldKey}`;
          const individualValue = changedValue[answerMetadata.editedRowIndex]?.[answerMetadata.editedFieldKey];
          
          // Only process logic if this specific field is a trigger field
          processIndividualFieldLogic(
            individualFieldKey,
            individualValue,
            allValues
          );
        } else {
          // Fallback: Process each row in the datagrid (old behavior)
          changedValue.forEach((rowData, rowIndex) => {
            Object.keys(rowData).forEach((columnKey) => {
              const individualFieldKey = `${changedFieldKey}[${rowIndex}].${columnKey}`;
              const individualValue = rowData[columnKey];

              // Process logic for this individual field change
              processIndividualFieldLogic(
                individualFieldKey,
                individualValue,
                allValues
              );
            });
          });
        }
        return;
      }

      // Process single field change
      processIndividualFieldLogic(changedFieldKey, changedValue, allValues);
    };

    // Separated logic processing for individual fields
    const processIndividualFieldLogic = (
      changedFieldKey,
      changedValue,
      allValues
    ) => {
      // Extract datagrid context from field key
      const datagridPattern = /^(\w+)\[(\d+)\]\.(\w+)$/;
      const datagridMatch = changedFieldKey.match(datagridPattern);
      let currentDatagridKey = null;
      let currentRowIndex = null;
      let currentRowData = null;
      let changedColumnKey = null;

      if (datagridMatch) {
        currentDatagridKey = datagridMatch[1];
        currentRowIndex = parseInt(datagridMatch[2]);
        changedColumnKey = datagridMatch[3];

        // Get current row data
        const datagridData = allValues[currentDatagridKey];
        if (Array.isArray(datagridData) && datagridData[currentRowIndex]) {
          currentRowData = { ...datagridData[currentRowIndex] };
          // Ensure the changed value is reflected in current row data
          currentRowData[changedColumnKey] = changedValue;
        }
      }

      // Check if this field is a trigger field for any logic
      let isaTriggerField = false;
      const formPages = tempFormAnswer?.form_schema?.formData;
      if (Array.isArray(formPages)) {
        for (const page of formPages) {
          const components = page?.content?.components;
          if (components) {
            const allComponents = findAllComponents(components);
            for (const component of allComponents) {
              if (component.logic && Array.isArray(component.logic)) {
                for (const logicRule of component.logic) {
                  const condition = logicRule?.trigger?.simple;
                  if (condition && condition.when) {
                    // Check if the changed field matches the trigger condition
                    if (
                      doesTriggerMatchChangedField(
                        condition.when,
                        changedFieldKey,
                        changedColumnKey,
                        currentDatagridKey
                      )
                    ) {
                      isaTriggerField = true;
                      break;
                    }
                  }
                }
                if (isaTriggerField) break;
              }
            }
            if (isaTriggerField) break;
          }
        }
      }

      if (!isaTriggerField) {
        return;
      }
      
      if (!Array.isArray(formPages)) {
        return;
      }

      let hasChanges = false;
      const updatesToApply = [];

      if (Array.isArray(formPages)) {
        formPages.forEach((page) => {
          const components = page?.content?.components;
          if (components) {
            const allComponents = findAllComponents(components);

            // Check each component for logic
            allComponents.forEach((component) => {
              if (!component.logic || !Array.isArray(component.logic)) return;

              // Determine if this component is in the same datagrid row as the changed field
              let componentRowIndex = null;
              let componentDatagridKey = null;
              let componentRowData = null;

              if (
                component.parentDatagridKey &&
                currentDatagridKey === component.parentDatagridKey
              ) {
                componentRowIndex = currentRowIndex;
                componentDatagridKey = component.parentDatagridKey;
                componentRowData = currentRowData;
              }

              // Process each logic rule for this component
              component.logic.forEach((logicRule, logicIndex) => {
                const { trigger, actions } = logicRule;

                if (!trigger || !actions) {
                  return;
                }
                // Check if this logic rule should be processed based on the trigger field
                let shouldProcessThisLogic = false;

                if (trigger.type === "simple") {
                  const condition = trigger.simple;
                  if (condition && condition.when) {
                    shouldProcessThisLogic = doesTriggerMatchChangedField(
                      condition.when,
                      changedFieldKey,
                      changedColumnKey,
                      currentDatagridKey
                    );
                  }
                }

                // ONLY PROCEED IF THIS LOGIC RULE IS TRIGGERED BY THE CHANGED FIELD
                if (!shouldProcessThisLogic) {
                  return; // Skip this logic rule entirely
                }

                // Now evaluate the condition since we know this rule should be processed
                let shouldTrigger = false;
                if (trigger.type === "simple") {
                  const condition = trigger.simple;
                  if (condition) {
                    shouldTrigger = evaluateCondition(
                      condition,
                      allValues,
                      componentRowData,
                      componentRowIndex,
                      componentDatagridKey
                    );
                  }
                }

                // Execute actions if triggered
                if (shouldTrigger && Array.isArray(actions)) {
                  actions.forEach((action, actionIndex) => {
                    const newValue = executeLogicAction(
                      action,
                      component,
                      allValues,
                      componentRowData
                    );
                    if (newValue !== null && component.key) {
                      let targetFieldKey = component.key;

                      // For datagrid components, construct proper field key
                      if (
                        component.parentDatagridKey &&
                        componentRowIndex !== null
                      ) {
                        targetFieldKey = `${component.parentDatagridKey}[${componentRowIndex}].${component.key}`;
                      }
                      updatesToApply.push({
                        key: targetFieldKey,
                        value: newValue,
                        component: component,
                        rowIndex: componentRowIndex,
                      });
                      hasChanges = true;
                    }
                  });
                }
              });
            });
          }
        });
      }
      // Apply all updates if there are changes
      if (hasChanges && updatesToApply.length > 0) {
        updatesToApply.forEach((update) => {
          updateFieldValueForLogic(
            update.key,
            update.value,
            update.component,
            update.rowIndex
          );
        });

        // Apply state updates for logic changes
        setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
        setAnswerData(updatedAnswerData);
        setCompleteJourneyAnswers(updatedJourneyAnswers);
        setFormAnswer(tempFormAnswer);
        setFormSchema(tempFormAnswer?.form_schema?.formData);
        setJourneyData(updatedJourneyData);
      }
    };

    // Enhanced field value updater to handle datagrid cell updates better
    const updateFieldValueForLogic = (
      fieldKey,
      newValue,
      component,
      rowIndex = null
    ) => {
      const logicAnswer = { value: newValue };
      const logicQuestion =
        component?.label ||
        fieldKey
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase());

      // Update tempAnswerList
      const existingIndex = tempAnswerList.findIndex(
        (item) => item.key === fieldKey
      );
      const answerItem = {
        key: fieldKey,
        question: logicQuestion,
        answer: logicAnswer,
      };

      if (existingIndex === -1) {
        tempAnswerList.push(answerItem);
      } else {
        tempAnswerList[existingIndex] = answerItem;
      }

      // Update updatedAnswerData
      updatedAnswerData[fieldKey] = logicAnswer;

      // Update journey answers
      const journeyIndex = updatedJourneyAnswers.findIndex(
        (item) => item.key === fieldKey
      );
      if (journeyIndex === -1) {
        updatedJourneyAnswers.push(answerItem);
      } else {
        updatedJourneyAnswers[journeyIndex] = answerItem;
      }

      // Enhanced component update logic
      const updateComponentRecursively = (
        components,
        currentRowIndex = null
      ) => {
        if (!Array.isArray(components)) return;

        components.forEach((comp) => {
          // Check direct match
          if (comp?.key === fieldKey) {
            if (!comp.answer) comp.answer = {};
            comp.answer.value = newValue;
            comp.formValidation = true;
          }

          // Handle datagrid components
          if (comp.type === "datagrid") {
            // Update datagrid components (column definitions)
            if (Array.isArray(comp.components)) {
              updateComponentRecursively(comp.components, currentRowIndex);
            }

            // Handle individual cell updates in datagrid
            const datagridPattern = new RegExp(
              `^${comp.key}\\[(\\d+)\\]\\.(\\w+)$`
            );
            const match = fieldKey.match(datagridPattern);

            if (match) {
              const [, matchedRowIndex, columnKey] = match;
              const targetRowIndex = parseInt(matchedRowIndex);

              // Ensure datagrid has answer structure
              if (!comp.answer) comp.answer = {};
              if (!comp.answer.value) comp.answer.value = [];

              // Ensure row exists
              if (!comp.answer.value[targetRowIndex]) {
                comp.answer.value[targetRowIndex] = {};
              }

              // Update the specific cell
              comp.answer.value[targetRowIndex][columnKey] = newValue;

              // Also update the component definition for the field
              comp.components.forEach((childComp) => {
                if (childComp.key === columnKey) {
                  if (!childComp.answer) childComp.answer = {};
                  childComp.answer.value = newValue;
                  childComp.formValidation = true;
                }
              });
            }
          }

          // Handle other nested components
          if (Array.isArray(comp.components)) {
            updateComponentRecursively(comp.components, currentRowIndex);
          }

          // Handle columns layout
          if (comp.type === "columns" && Array.isArray(comp.columns)) {
            comp.columns.forEach((column) => {
              if (Array.isArray(column.components)) {
                updateComponentRecursively(column.components, currentRowIndex);
              }
            });
          }
        });
      };

      // Update form structure
      tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
        if (formPage?.content?.components) {
          updateComponentRecursively(formPage.content.components, rowIndex);
        }
      });

      // Update journey data structure
      let targetFormId = null;
      let targetFormPageId = null;

      screens?.forEach((screen) => {
        screen?.screenPages?.forEach((screenPage) => {
          const form = screenPage?.components?.form?.form_schema?.formData;
          form?.forEach((formPageItem) => {
            if (formPageItem?.content?.components) {
              // Find the target form info
              const findTargetInfo = (components) => {
                components.forEach((comp) => {
                  if (
                    comp?.key === fieldKey ||
                    (comp.type === "datagrid" &&
                      fieldKey.startsWith(comp.key + "["))
                  ) {
                    if (!targetFormId)
                      targetFormId = screenPage?.components?.formId;
                    if (!targetFormPageId) targetFormPageId = formPageItem?.id;
                  }

                  // Check nested components
                  if (Array.isArray(comp.components)) {
                    findTargetInfo(comp.components);
                  }

                  // Check columns
                  if (comp.type === "columns" && Array.isArray(comp.columns)) {
                    comp.columns.forEach((column) => {
                      if (Array.isArray(column.components)) {
                        findTargetInfo(column.components);
                      }
                    });
                  }
                });
              };

              findTargetInfo(formPageItem.content.components);

              // Update the components
              updateComponentRecursively(
                formPageItem.content.components,
                rowIndex
              );
            }
          });
        });
      });

      // Add to trigger body
      addAnswerToTriggerBody(
        targetFormId || formData?.formId,
        targetFormPageId || activeFormPageId,
        {
          label: logicQuestion,
          key: fieldKey,
          type: component?.type || "textfield",
        },
        logicAnswer
      );
    };

    // Process form logic after all other processing is complete
    // Only process logic if this field is a trigger field for other logic
    const isTriggerFieldForLogic = checkIfTriggerField(questionKey, tempFormAnswer);
    if (isTriggerFieldForLogic) {
      processFormLogic(questionKey, answer?.value, answer);
    }
  };

  const handleBack = () => {
    for (let i = 0; i < formSchema.length; i++) {
      if (formSchema[i].id === activeFormPageId) {
        if (i > 0) {
          setActiveFormPage(formSchema[i - 1].content);
          setActiveFormPageId(formSchema[i - 1].id);
        } else if (i === 0) {
          handleBackScreenPage();
        }
      }
    }
  };
  const handleNext = () => {
    let nextActionValid = true;
    for (let i = 0; i < formSchema.length; i++) {
      if (formSchema[i].id === activeFormPageId) {
        formSchema[i].content.components.map((questionData) => {
          if (
            checkForQuestionToShow(questionData) &&
            questionData?.validate?.required &&
            !questionData?.answer
          ) {
            nextActionValid = false;
            setFormValidation(false);
          }
        });
      }
    }
    if (formData?.formId === "66ff55385b3a1419fb71ad79") {
      if (answerData?.doYouHaveMedicare?.value === "yes") {
        nextActionValid = false;
        setOpenModal(true);
        setModalTitle("Redirecting you to");
        setModalSubtitle("Synaptrx");
        setTimeout(() => {
          window.open(
            "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
            "_blank" // This specifies opening in a new tab
          );

          setOpenModal(false);
          setModalTitle("");
          setModalSubtitle("");
        }, 3000);
      }
    }

    if (formData?.formId === "66ff6e1e5b3a1419fb71b410") {
      if (answerData?.doYouHaveMedicare?.value === "yes") {
        nextActionValid = false;
        setOpenModal(true);
        setModalTitle("Redirecting you to");
        setModalSubtitle("Synaptrx");
        setTimeout(() => {
          window.open(
            "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
            "_blank" // This specifies opening in a new tab
          );

          setOpenModal(false);
          setModalTitle("");
          setModalSubtitle("");
        }, 3000);
      } else if (answerData?.doYouHaveMedicare?.value === "no") {
        if (answerData?.areYouUsingInsuranceForThisVisit?.value === "yes") {
          nextActionValid = false;
          setOpenModal(true);
          setModalTitle("Redirecting you to");
          setModalSubtitle("Synaptrx");
          setTimeout(() => {
            window.open(
              "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
              "_blank" // This specifies opening in a new tab
            );
            setOpenModal(false);
            setModalTitle("");
            setModalSubtitle("");
          }, 3000);
        }
      }
    }

    if (
      formData?.formId === "66ec5b455b3a1419fb717b99" ||
      formData?.formId === "68525a6f4ef9cc55588fb84b" ||
      formData?.formId === "6819ad9dc4f18e73b7d06d38"
    ) {
      if (
        answerData?.iDontWantToAddMyCardOnFile &&
        answerData.iDontWantToAddMyCardOnFile?.value == true
      ) {
        nextActionValid = false;
        handleSubmit();
      }
    }

    if (nextActionValid) {
      for (let i = 0; i < formSchema.length; i++) {
        if (formSchema[i].id === activeFormPageId) {
          if (i < formSchema.length - 1) {
            setActiveFormPage(formSchema[i + 1].content);
            setActiveFormPageId(formSchema[i + 1].id);
            setFormValidation(true);
          }
        }
      }
    }
  };

  const handleSubmit = async () => {
    // let tempFormAnswer = JSON.parse(JSON.stringify(formAnswer));
    let tempFormAnswer = deepCloneWithFiles(formAnswer);

    // let updatedAnswerData = JSON.parse(JSON.stringify(answerData));
    let updatedAnswerData = deepCloneWithFiles(answerData);

    let updatedJourneyAnswers = JSON.parse(
      JSON.stringify(completeJourneyAnswers)
    );

    // let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let updatedJourneyData = deepCloneWithFiles(journeyData);
    // ESS Calculation
    if (
      formData?.formId === "65d62c01b9482fa2f0d8cac4" ||
      formData?.formId === "687d98498c698bdf457450e7" ||
      formData?.formId === "68820395fe01cd182f200981"
    ) {
      const scoreObj = {
        noChanceOfDozing: 0,
        slightChanceOfDozing: 1,
        moderateChanceOfDozing: 2,
        highChanceOfDozing: 3,
        0: 0,
        1: 1,
        2: 2,
        3: 3,
      };
      let essScore = 0;
      const essQuestions = [
        "sittingAndReading",
        "watchingTv",
        "sittingInactiveInAPublicPlaceEGATheaterOrAMeeting",
        "asAPassengerInACarForAnHourWithoutABreak",
        "lyingDownToRestInTheAfternoonWhenCircumstancesPermit",
        "sittingAndTalkingToSomeone",
        "sittingQuietlyAfterALunchWithoutAlcohol",
        "inACarWhileStoppedForAFewMinutesInTraffic",
        "sittingAndReadingTSO",
        "watchingTvTSO",
        "sittingInactiveInAPublicPlaceEGATheaterOrAMeetingTSO",
        "asAPassengerInACarForAnHourWithoutABreakTSO",
        "lyingDownToRestInTheAfternoonWhenCircumstancesPermitTSO",
        "sittingAndTalkingToSomeoneTSO",
        "sittingQuietlyAfterALunchWithoutAlcoholTSO",
        "inACarWhileStoppedForAFewMinutesInTrafficTSO",
      ];
      essQuestions.forEach((question) => {
        const answer = answerData?.[question]?.value;
        if (answer && scoreObj[answer] !== undefined) {
          essScore += scoreObj[answer];
        }
      });
      const essAnswer = { value: essScore };
      const essQuestion = {
        label: "ESS Score",
        key: "essScore",
        type: "textfield",
      };

      let screens = updatedJourneyData?.journey_schema?.screens;

      // Update updatedAnswerData
      updatedAnswerData["essScore"] = essAnswer;

      // Update journey answers
      let essjourneyIndex = updatedJourneyAnswers.findIndex(
        (item) => item.key === "essScore"
      );
      if (essjourneyIndex === -1) {
        updatedJourneyAnswers.push({
          key: "essScore",
          question: "ESS Score",
          answer: essAnswer,
        });
      } else {
        updatedJourneyAnswers[essjourneyIndex].answer = essAnswer;
      }

      // Update form structure
      tempFormAnswer?.form_schema?.formData?.map((formPage) => {
        formPage?.content?.components.map((item) => {
          if (item?.key === "essScore") {
            item.answer = essAnswer;
            item.formValidation = true;
          }
        });
      });

      // Update journey data structure
      for (let i = 0; i < screens?.length; i++) {
        if (screens[i]?.id === activeScreenID) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            if (screenPages[j]?.id === activeScreenPageID) {
              let form =
                screenPages[j]?.components?.form?.form_schema?.formData;
              for (let idx = 0; idx < form?.length; idx++) {
                // if (form[idx]?.id === activeFormPageId) {
                let formContent = form[idx]?.content?.components;
                formContent?.map((ques) => {
                  if (ques?.key === "essScore") {
                    ques.answer = essAnswer;
                    ques.formValidation = true;
                  }
                });
                // }
              }
            }
          }
        }
      }

      // Add to trigger body
      addAnswerToTriggerBody(
        formData?.formId,
        activeFormPageId,
        essQuestion,
        essAnswer
      );

      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setJourneyData(updatedJourneyData);
    }

    // Total Charges Calculation
    if (formData?.formId === "6838079366e091a6310b5bf1") {
      let totalCharges = 0;
      let totalPaid = 0;
      let totalDue = 0;

      const fee1 = answerData?.["fees"]?.value || 0;
      const fee2 = answerData?.["fees1"]?.value || 0;
      const fee3 = answerData?.["fees2"]?.value || 0;
      const fee4 = answerData?.["fees3"]?.value || 0;

      const paid1 = answerData?.["amountPaid"]?.value || 0;
      const paid2 = answerData?.["amountPaid1"]?.value || 0;
      const paid3 = answerData?.["amountPaid2"]?.value || 0;
      const paid4 = answerData?.["amountPaid3"]?.value || 0;

      const due1 = answerData?.["amountDue"]?.value || 0;
      const due2 = answerData?.["amountDue1"]?.value || 0;
      const due3 = answerData?.["amountDue2"]?.value || 0;
      const due4 = answerData?.["amountDue3"]?.value || 0;
      totalCharges =
        parseFloat(fee1) +
        parseFloat(fee2) +
        parseFloat(fee3) +
        parseFloat(fee4);
      totalPaid =
        parseFloat(paid1) +
        parseFloat(paid2) +
        parseFloat(paid3) +
        parseFloat(paid4);
      totalDue =
        parseFloat(due1) +
        parseFloat(due2) +
        parseFloat(due3) +
        parseFloat(due4);
      addAnswerToTriggerBody(
        formData?.formId,
        activeFormPageId,
        { key: "totalCharges", label: "Total Charges" },
        { value: totalCharges }
      );
      addAnswerToTriggerBody(
        formData?.formId,
        activeFormPageId,
        { key: "totalPaid", label: "Total Paid" },
        { value: totalPaid }
      );
      addAnswerToTriggerBody(
        formData?.formId,
        activeFormPageId,
        { key: "totalDue", label: "Total Due" },
        { value: totalDue }
      );
    }

    let nextActionValid = true;
    for (let i = 0; i < formSchema.length; i++) {
      if (formSchema[i].id === activeFormPageId) {
        formSchema[i].content.components.map((questionData) => {
          if (
            checkForQuestionToShow(questionData) &&
            questionData?.validate?.required &&
            !(
              questionData?.answer &&
              questionData.answer?.value &&
              questionData.answer.value !== ""
            )
          ) {
            questionData.formValidation = false;
            nextActionValid = false;
            setFormValidation(false);
          }
        });
        setActiveFormPage(formSchema[i].content);
      }
    }
    // Handle API calls and set nextActionValid to false if any fail
    const apiCalls = [
      formData?.formId === "66e90d445b3a1419fb7131ce" && uploadDemographics(),
      formData?.formId === "68525ab44ef9cc55588fb84c" && uploadDemographics(),
      formData?.formId === "6819ade2c4f18e73b7d06d3c" && uploadDemographics(),
      formData?.formId === "66e916775b3a1419fb713231" && uploadAdditionalInfo(),
      formData?.formId === "6819ae30c4f18e73b7d06d43" && uploadAdditionalInfo(),
      formData?.formId === "68525adc4ef9cc55588fb84d" && uploadAdditionalInfo(),
      formData?.formId === "66e918895b3a1419fb7132b7" && uploadInsurance(),
      formData?.formId === "68525b174ef9cc55588fb84e" && uploadInsurance(),
      formData?.formId === "6819af55c4f18e73b7d06d4d" && uploadInsurance(),
      formData?.formId === "66eaaec35b3a1419fb715735" && uploadPharmacy(),
      formData?.formId === "68525b3c4ef9cc55588fb84f" && uploadPharmacy(),
      formData?.formId === "6819af94c4f18e73b7d06d51" && uploadPharmacy(),
      formData?.formId === "66e919305b3a1419fb7132de" && uploadCareTeam(),
      formData?.formId === "68525b5f4ef9cc55588fb850" && uploadCareTeam(),
      formData?.formId === "6819afc1c4f18e73b7d06d55" && uploadCareTeam(),
      formData?.formId === "66e947e15b3a1419fb71449f" &&
        uploadMedicalCondition(),
      formData?.formId === "68525b7b4ef9cc55588fb851" &&
        uploadMedicalCondition(),
      formData?.formId === "6819aff5c4f18e73b7d06d59" &&
        uploadMedicalCondition(),
      formData?.formId === "66e919bd5b3a1419fb7132e5" &&
        uploadSocialCondition(),
      formData?.formId === "68525b9d4ef9cc55588fb852" &&
        uploadSocialCondition(),
      formData?.formId === "6819b02fc4f18e73b7d06d5d" &&
        uploadSocialCondition(),
      formData?.formId === "66e91dbc5b3a1419fb713308" && uploadPrivacy(),
      formData?.formId === "68525c114ef9cc55588fb855" && uploadPrivacy(),
      formData?.formId === "6819b100c4f18e73b7d06d65" && uploadPrivacy(),
      formData?.formId === "66ec5b455b3a1419fb717b99" && uploadPaymentDetails(),
      formData?.formId === "6819ad9dc4f18e73b7d06d38" && uploadPaymentDetails(),
      formData?.formId === "68525a6f4ef9cc55588fb84b" && uploadPaymentDetails(),
      // formData?.formId === "67d8411bef153122f8b7ee61" && uploadSleepTest(),
      // formData?.formId === "6819acc5c4f18e73b7d06d2e" && uploadSleepTest(),
    ];

    for (let apiCall of apiCalls) {
      if (apiCall) {
        setShowLoader(true);
        setLoaderMessage("Submitting your Data...");
        const response = await apiCall;
        nextActionValid = response;
        if (response?.error) {
          nextActionValid = false; // Set to false if any API fails
          break; // Stop further API calls if one fails
        }
      }
      setShowLoader(false);
      setLoaderMessage("");
    }

    if (journeyInstanceId) {
      const response = updateJourneyDataForInstanceId(journeyInstanceId, {
        journey_schema: updatedJourneyData?.journey_schema,
        status: "IN_PROGRESS",
      });
    }

    if (nextActionValid) {
      newFormSubmit(formattedAnswer, formData?.form?.org);
      newFormSubmitForTriggers(
        tempFormAnswer,
        formData?.form?._id,
        formTriggers
      );
      setShowLoader(true); // Show loader before starting workflow checks
      setLoaderMessage("Compiling data...");
      // let workflowCompletion = await triggerAttachedWorkflows();
      setShowLoader(false); // Hide loader after completion
      setLoaderMessage("");

      // workflowCompletion && handleNextScreenPage();
      handleNextScreenPage(updatedJourneyData);
    }
  };

  const getTriggerUrl = async (triggerId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    // const triggerAPIUrl = `${API_URL}/api/v1/webhooks/${triggerId}`;
    const triggerAPIUrl = `${API_URL}/api/v1/webhooks/open/formSubmission/${triggerId}`;
    const response = await axios.get(triggerAPIUrl);
    if (response && response.data) {
      return response.data.url;
    }
    return null;
  };

  const triggerAttachedWorkflows = async () => {
    const formId = formData?.formId;
    let workflowInstances = [];

    if (formTriggers.triggers.length > 0) {
      // Use the correct trigger body based on configuration
      let triggerBody = {
        journeyData: formTriggers.singleFormBody
          ? { [formId]: qnABodyForTriggers[formId] }
          : qnABodyForTriggers,
        appointmentHash: hashIdFromQP || null,
      };
      if (!triggerBody) {
        triggerBody = {}; // Provide a default empty object or appropriate default
      }

      // Trigger all workflows
      for (let i = 0; i < formTriggers.triggers.length; i++) {
        let trigger = formTriggers.triggers[i];
        let triggerUrl = await getTriggerUrl(trigger);

        if (triggerUrl) {
          try {
            let response = await axios.post(triggerUrl, triggerBody);
            if (response?.data?.workflowInstances) {
              workflowInstances = [
                ...workflowInstances,
                ...response.data.workflowInstances,
              ];
            }
          } catch (error) {
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
            }
            return false; // Return false if any trigger fails
          }
        }
      }
    }

    // If we don't need to wait for workflow completion, return true immediately
    if (!formTriggers.waitForWorkflowCompletion) {
      return true;
    }

    // Otherwise, poll for completion status of all workflow instances
    return await checkAllWorkflowsCompletion(workflowInstances);
  };

  const checkAllWorkflowsCompletion = async (instanceIds) => {
    if (!instanceIds.length) return true;

    const MAX_ATTEMPTS = 20; // Maximum 3 minutes (60 * 3 seconds)
    let attempts = 0;

    // Keep checking until we reach max attempts
    while (attempts < MAX_ATTEMPTS) {
      let allCompleted = true;
      let anyFailed = false;

      // Check status of each workflow instance
      for (let instanceId of instanceIds) {
        const status = await checkWorkflowCompletion(instanceId);

        if (status === "FAILED") {
          anyFailed = true;
          break; // Exit early if any workflow fails
        } else if (status !== "SUCCESS") {
          allCompleted = false; // Not all are completed yet
        }
      }

      // If any failed, return false
      if (anyFailed) {
        return false;
      }

      // If all completed successfully, return true
      if (allCompleted) {
        return true;
      }

      // Wait for 3 seconds before next check
      await new Promise((resolve) => setTimeout(resolve, 3000));
      attempts++;
    }

    // If we reached max attempts without all completing successfully,
    // we consider it a timeout failure
    console.error("Workflow completion check timed out after 1 minutes");
    return false;
  };

  const checkWorkflowCompletion = async (instanceId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    const workflowAPIUrl = `${API_URL}/api/v1/workflow-instances/${instanceId}`;

    try {
      const response = await axios.get(workflowAPIUrl);
      if (response?.data) {
        return response.data.status; // Returns one of: PENDING, FAILED, RUNNING, PAUSED, SUCCESS
      }
    } catch (error) {
      console.error(`Error checking workflow status for ${instanceId}:`, error);
      return "FAILED"; // Consider API errors as failures
    }

    return "PENDING"; // Default to PENDING if no valid response
  };

  const checkForQuestionToShow = (ques) => {
    let show = true;
    if (ques?.conditional && ques.conditional?.eq && ques.conditional?.when) {
      show = !ques.conditional?.show;
      let journeyAnswerIndex = completeJourneyAnswers.findIndex(
        (item) => item.key === ques.conditional.when
      );
      let answer = completeJourneyAnswers[journeyAnswerIndex]?.answer?.value;
      if (
        (typeof answer === "string" && answer === ques.conditional?.eq) ||
        (Array.isArray(answer) && answer.includes(ques.conditional?.eq)) ||
        (Array.isArray(ques.conditional?.eq) &&
          typeof answer === "string" &&
          ques.conditional?.eq.includes(answer)) ||
        (typeof answer === "boolean" && answer == ques.conditional?.eq) ||
        (typeof answer === "object" &&
          answer !== null &&
          !Array.isArray(answer) &&
          // Check if conditional.eq is a key in the answer object and it's true
          ((typeof ques.conditional?.eq === "string" &&
            answer[ques.conditional.eq] === true) ||
            // Check if conditional.eq is an array and any of its values are keys with true values
            (Array.isArray(ques.conditional?.eq) &&
              ques.conditional.eq.some((key) => answer[key] === true))))
      ) {
        show = ques.conditional?.show || false;
      }
    }
    return show;
  };

  useEffect(() => {
    if (formData) {
      setFormattedAnswer({
        type: formData?.type,
        formId: formData.formId,
        answers: [],
      });
      fetchFormSchema(formData);
      callAthenaAPIs();
    }
    function checkPatientDepartmentKey(formSchemaData, targetKey) {
      // Check if formData exists and is an array
      if (
        !formSchemaData.form_schema ||
        !formSchemaData.form_schema.formData ||
        !Array.isArray(formSchemaData.form_schema.formData)
      ) {
        return {
          exists: false,
          message: "Invalid form schema structure",
        };
      }

      // Iterate through each form page
      for (const page of formSchemaData.form_schema.formData) {
        // Check if the page has content and components
        if (
          page.content &&
          page.content.components &&
          Array.isArray(page.content.components)
        ) {
          // Search through components for the target key
          for (const component of page.content.components) {
            if (component.key === targetKey) {
              return component.answer ? component.answer.value : null;
            }
          }
        }
      }

      // Key not found
      return null;
    }
    if (
      formData?.formId === "6819ab3ec4f18e73b7d06d0e" ||
      formData?.formId === "66fe0d935b3a1419fb71a96d" ||
      formData?.formId === "686b682dc92b0a640c372127" ||
      formData?.formId === "685259b64ef9cc55588fb849"
    ) {
      fetchAllDepartments();
      if (formData?.form) {
        const departmentId = checkPatientDepartmentKey(
          formData?.form,
          "patientDepartmentForSchedulerForSpecificForm"
        );
        departmentId && fetchAllReasons(departmentId);
      }
    }
    
    // For form ID 695fd35988dae1609a365821, just set the pre-selected values without API calls
    if (formData?.formId === "695fd35988dae1609a365821" || formData?.formId === "6964509688dae1609a365edb") {
      // Extract default values directly from form schema
      const formPages = formData?.form?.form_schema?.formData;
      if (Array.isArray(formPages)) {
        formPages.forEach((page) => {
          if (page?.content?.components && Array.isArray(page.content.components)) {
            page.content.components.forEach((component) => {
              if (component?.key === "patientDepartmentForSchedulerForSpecificForm1" && component?.defaultValue) {
                setAnswerData((prev) => ({
                  ...prev,
                  patientDepartmentForSchedulerForSpecificForm: { value: component.defaultValue },
                }));
              }
              if (component?.key === "reasonForVisitForScheduler" && component?.defaultValue) {
                setAnswerData((prev) => ({
                  ...prev,
                  reasonForVisitForScheduler: { value: component.defaultValue },
                }));
              }

              if (component?.key === "preferredProviderForScheduler" && component?.defaultValue) {
                setAnswerData((prev) => ({
                  ...prev,
                  preferredProviderForScheduler: { value: component.defaultValue },
                }));
              }
            });
          }
        });
      }
    }
  }, [formData]);

  const fetchAllDepartments = async () => {
    setShowLoader(true);
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    // hardcoded scheduler id for now, will make it dynamic during journey refactor. 67500bf9f24586aa9894a48c
    let allDepartmentsAPIUrl = "";
    if (formData?.formId === "6819ab3ec4f18e73b7d06d0e")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/6818e400362163c857cee438/departments`;
    if (formData?.formId === "66fe0d935b3a1419fb71a96d")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/67d8416ea9a925a0cd064b3c/departments`;
    if (formData?.formId === "686b682dc92b0a640c372127")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/67d8416ea9a925a0cd064b3c/departments`;
    if (formData?.formId === "685259b64ef9cc55588fb849")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/685258257141029067a64e30/departments`;
    const response = await axios.get(allDepartmentsAPIUrl);

    if (response && response.data) {
      const allDepartments = response.data?.HBx?.departments?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.departmentId,
        };
      });
      setAllDepartmentsForSpecificForm(allDepartments);
    }
    setShowLoader(false);
  };
  const fetchAllReasons = async (department_id) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    // hardcoded scheduler id for now, will make it dynamic during journey refactor
    let allReasonsAPIUrl = "";
    if (formData?.formId === "6819ab3ec4f18e73b7d06d0e")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/6818e400362163c857cee438/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "66fe0d935b3a1419fb71a96d")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/67d8416ea9a925a0cd064b3c/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "686b682dc92b0a640c372127")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/67d8416ea9a925a0cd064b3c/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "685259b64ef9cc55588fb849")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/685258257141029067a64e30/reasons?departmentId=${department_id}&providerId=-1`;

    const response = await axios.get(allReasonsAPIUrl);

    if (response && response.data) {
      const allReasons = response.data?.HBx?.patientappointmentreasons?.map(
        (item) => {
          return {
            ...item,
            label: item?.reason,
            value: item?.reasonid,
            Description: item?.description,
          };
        }
      );
      setAllReasonsForSpecificForm(allReasons);
    }
  };

  useEffect(() => {
    setActiveFormPage(activeFormPageData?.content);
    setActiveFormPageId(activeFormPageData?.id);
    window.scrollTo(0, 0); // Scroll to top when form page changes
  }, [activeFormPageData]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when form page changes
  }, [activeFormPageId]);

  const handleContainerKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default action on pressing Enter
    }
  };

  return (
    <div className="w-auto" onKeyDown={handleContainerKeyDown}>
      <div className="w-auto p-5">
        {showloader ? (
          <div className=" flex flex col min-h-96 justify-center items-center">
            <Loader message={loaderMessage} />
          </div>
        ) : (
          <>
            {(formData?.formId === insuranceForm ||
              formData?.formId === "68525b174ef9cc55588fb84e" ||
              formData?.formId === insuranceFormProd) &&
            insuranceCollectedStatus ? (
              <div className="content-width">
                <div className="flex flex-col">
                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                    Insurance Collected for this Checkin
                  </div>
                </div>
              </div>
            ) : (formData?.formId === paymentForm ||
                formData?.formId === "68525a6f4ef9cc55588fb84b" ||
                formData?.formId === paymentFormProd) &&
              paymentCollectedStatus ? (
              <div className="content-width">
                <div className="flex flex-col">
                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                    Payment Details Collected for this Checkin
                  </div>
                </div>
              </div>
            ) : (
              <>
                {activeFormPage &&
                  activeFormPage?.components &&
                  activeFormPage?.components?.map((item, index) => {
                    // First check if we should show this question at all

                    const shouldShow =
                      checkForQuestionToShow(item) && !item?.hidden;
                    const isConditional =
                      item?.conditional &&
                      item.conditional?.eq &&
                      item.conditional?.when;

                    // if (!checkForQuestionToShow(item)) {
                    //   return null;
                    // }
                    if (!isConditional && !shouldShow) {
                      return null;
                    }

                    // Then render the appropriate component based on type
                    let FormComponent = null;
                    let specialProps = {};

                    switch (item?.type) {
                      case "textfield":
                        FormComponent = TextField;
                        break;
                      case "heightField":
                        FormComponent = HeightField;
                        break;
                      case "americanPhoneField":
                        FormComponent = AmericanPhoneField;
                        break;
                      case "textarea":
                        FormComponent = TextArea;
                        break;
                      case "password":
                        FormComponent = Password;
                        break;
                      case "datetime":
                        FormComponent = DateInput;
                        break;
                      case "dob":
                        FormComponent = DateInput;
                        break;
                      case "email":
                        FormComponent = Email;
                        break;
                      case "checkbox":
                        FormComponent = SingleCheckBox;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "select":
                        FormComponent = DropDownSelector;

                        // Special case for department selector
                        if (
                          item?.key ===
                          "patientDepartmentForSchedulerForSpecificForm"
                        ) {
                          specialProps = {
                            data: {
                              ...item,
                              data: { values: allDepartmentsForSpecificForm },
                            },
                          };
                        }
                        break;
                      case "number":
                        FormComponent = NumberInput;
                        break;
                      case "phoneNumber":
                        FormComponent = Telephone;
                        break;
                      case "dropDownWithSearch":
                        FormComponent = DropDownWithSearch;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "radio":
                        FormComponent = RadioSelector;
                        // Special case for reason selector
                        if (item?.key === "reasonForVisitForScheduler") {
                          specialProps = {
                            data: {
                              ...item,
                              values: allReasonsForSpecificForm,
                            },
                          };
                        }
                        break;
                      case "content":
                        FormComponent = ContentRenderer;
                        break;
                      case "datagrid":
                        FormComponent = DataGrid;
                        specialProps = {
                          allDepartmentsForSpecificForm,
                          allReasonsForSpecificForm,
                        };
                        break;
                      case "columns":
                        FormComponent = Columns;
                        specialProps = {
                          allDepartmentsForSpecificForm,
                          allReasonsForSpecificForm,
                        };
                        break;
                      case "file":
                        FormComponent = UploadFile;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "selectboxes":
                        FormComponent = CheckBoxSelector;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "dynamicContentRenderer":
                        FormComponent = DynamicContentRenderer;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "healthHistoryAllergyComponent":
                        FormComponent = HealthHistoryAllergyComponent;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "healthHistoryMedicationComponent":
                        FormComponent = HealthHistoryMedicationComponent;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      default:
                        return null; // Unknown component type
                    }

                    // Handle special case for select component data
                    const itemData =
                      item.type === "select" &&
                      item.key ===
                        "patientDepartmentForSchedulerForSpecificForm"
                        ? {
                            ...item,
                            data: { values: allDepartmentsForSpecificForm },
                          }
                        : item.type === "radio" &&
                          item.key === "reasonForVisitForScheduler"
                        ? {
                            ...item,
                            values: allReasonsForSpecificForm,
                          }
                        : item;

                    if (FormComponent) {
                      return (
                        <div
                          key={index}
                          className={`${
                            isConditional
                              ? `form-width  ${
                                  deviceType === "laptop"
                                    ? "ml-12"
                                    : deviceType === "tablet"
                                    ? "ml-8"
                                    : "ml-4"
                                } mx-auto flex justify-center conditional-question ${
                                  shouldShow ? "show" : ""
                                }`
                              : "form-width mx-auto flex justify-center my-3"
                          }`}
                        >
                          <FormComponent
                            data={specialProps.data || itemData}
                            setAnswer={setAnswer}
                            formClass={formClass}
                            formValidation={
                              specialProps.formValidation || formValid
                            }
                            {...specialProps}
                          />
                        </div>
                      );
                    }

                    return null;
                  })}
              </>
            )}
          </>
        )}
        {openModal ? (
          <>
            <ModalBox
              openModal={true}
              title={modalTitle}
              SubTitle={modalSubtitle}
              hideClose={true}
              showButtons={false}
              showIcon={false}
              maxWidth={600}
            />
          </>
        ) : (
          <></>
        )}
      </div>
      <div className="bottom-bar-shadow">
        <div className="flex justify-between pt-3 m-auto bottom-bar w-full">
          {firstPageFirstFormID === activeFormPageId ? (
            <div className="text-xs text-gray-600 max-w-[65%] content-center">
              By clicking Next/Submit, you agree to our{" "}
              <a
                href="https://dashboard-sandbox.healthblox.care/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://dashboard-sandbox.healthblox.care/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Privacy Policy
              </a>
              .
            </div>
          ) : (
            <button
              onClick={() => !showloader && handleBack()}
              className="text_button"
            >
              Back
            </button>
          )}

          {formSchema &&
          formSchema[formSchema?.length - 1]?.id === activeFormPageId ? (
            <div
              onClick={() => !showloader && handleSubmit()}
              className="primary_button"
            >
              {isLastForm ? "Submit" : "Next"}
            </div>
          ) : (
            <div
              onClick={() => !showloader && handleNext()}
              className="primary_button"
            >
              Next
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormRenderer;
